import moment from 'moment';
import Cropper from 'react-cropper';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import Switch from '@mui/material/Switch';
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { FormControl, InputLabel, MenuItem, Select, Checkbox, ListItemText, TextField } from "@mui/material";

import 'cropperjs/dist/cropper.css';
import 'react-circular-progressbar/dist/styles.css';
import { hasValidAdvisor } from '../BusinessCards.js';
import InvestorMatchCriteria from './InvestorMatchCriteria.js';
import AdvisorMatchCriteria from './AdvisorMatchCriteria.js';
import AnimatedPage from "../../../../components/AnimatedPage.js";
import { toggleModal } from "../../../../reducers/modalReducer.js";
import { getRequest, postRequest, showMessage } from '../../../../config.js';
import SuperFlowHeader from "../../../../components/header/SuperFlowHeader.js";

const cropper = React.createRef(null);

export default function Settings({ profileClass, getCompany, handleMemberEdit }) {

	const dispatch = useDispatch();

	let user = useSelector(state => state.user);
	let modal = useSelector(state => state.modal);
	let companies = useSelector(state => state.companies);
	let companyId = location.pathname.split("/").slice(-1)[0];
	const isCompanySettings = window.location.pathname.includes("company-settings");

	let [cvData, setCvData] = useState({});
	let [company, setCompany] = useState({});
	let [director, setDirector] = useState('');
	let [isValid, setIsValid] = useState(true);
	let [advisors, setAdvisors] = useState([]);
	let [investors, setInvestors] = useState([]);
	let [editInput, setEditInput] = useState('');
	let [attachment, setAttachment] = useState();
	let [uploadType, setUploadType] = useState('');
	let [advisorLogo, setAdvisorLogo] = useState();
	let [promptScore, setPromptScore] = useState(0);
	let [auditLogList, setAuditLogList] = useState([]);
	let [currentImage, setCurrentImage] = useState('');
	let [isImageModal, setIsImageModal] = useState(false);
	let [companyContact, setCompanyContact] = useState({});
	let [chargeReadMore, setChargeReadMore] = useState({});
	let [selectedStages, setSelectedStages] = useState([]);
	let [controlReadMore, setControlReadMore] = useState({});
	let [selectedSectors, setSelectedSectors] = useState([]);
	let [officersReadMore, setOfficersReadMore] = useState({});
	let [selectedContact, setSelectedContact] = useState(null);
	let [filingCurrentPage, setFilingCurrentPage] = useState(0);
	let [isMainRecipient, setIsMainRecipient] = useState(false);
	let [updateCompanyData, setUpdateCompanyData] = useState({});
	let [selectedUKRegions, setSelectedUKRegions] = useState({});
	let [isSettingsChanged, setSettingsChanged] = useState(false);
	let [updateSettingsData, setUpdateSettingsData] = useState({});
	let [indexTab, setIndexTab] = useState('Companies House Data');
	let [personsCurrentPage, setPersonsCurrentPage] = useState(0);
	let [chargesCurrentPage, setChargesCurrentPage] = useState(0);
	let [officersCurrentPage, setOfficersCurrentPage] = useState(0);
	let [registersCurrentPage, setRegistersCurrentPage] = useState(0);
	let [isInvestorMatchTabs, setIsInvestorMatchTabs] = useState(false);
	let [isClientMatchTabs, setIsClientMatchTabs] = useState(false);
	let [investorLeadQuestions, setInvestorLeadQuestions] = useState([]);
	let [tabCompanySnapshot, setTabCompanySnapshot] = useState('Filing History');
	let [leadSectionActive, setLeadSectionActive] = useState('Standard Questions');
	let [formData, setFormData] = useState({ linkedIn: '', companyId: '', directorId: '' });
	let [selectedInvestorTab, setSelectedInvestorTab] = useState(`${user?.['role'] || ''} Details`);
	let [selectedClientMatchTab, setSelectedClientMatchTab] = useState('Team Admin');
	let [newContact, setNewContact] = useState({ firstName: '', lastName: '', email: '', phone: '', profilePicture: '', linkedIn: '' });

	let clientMatchTabs = ['Team Admin', 'Profiles', 'Skills & Experience', 'Objective Criteria', 'Quick Response'];
	let investorMatchTabs = [`${user?.['role'] || ''} Details`, 'Objective Criteria', 'Subjective Criteria', 'Quick Response'];

	let options = {
		empty: ['', 'not known', 'not selected', 'none selected', 'nil'],
		cStages: ["Pre-Revenue", "Post-Revenue Early Stage", "Mature"],
		noOfInvestments: ['<10', '10-20', '20-100', '>100', 'Not known'],
		fundSizes: ['<£5m', '£5m-£100m', '£100m-£500m', '£500m-£1bn', '>£1bn', 'Not known'],
		lastInvestmentDate: ['Within 6 months', 'Within 12 months', 'More than 12 months', 'Not known'],
		profits: ['Nil', '<£100,000', '£100,000-£500,000', '£500,001-£1m', '>£1m ARR', '£1m-£5m', '£5m-£10m', '£10m-£20m', '£20m-£100m', '£100m+', 'Not known'],
		revenues: ['Nil', '<£100,000', '£100,000-£500,000', '£500,001-£1m', '>£1m ARR', '£1m-£5m', '£5m-£10m', '£10m-£20m', '£20m-£100m', '£100m+', 'Not known'],
		sweetSpots: ['<£100,000', '£100,001-£1,000,000', '£1,000,001-£5,000,000', '£5,000,001-£20,000,000', '£20,000,001-£100,000,000', '>£100,000,001', 'Not known'],
		stages: ['Angel', 'Pre-Seed', 'Seed', 'Venture Capital - Series A', 'Venture Capital - Series B+', 'Private Equity', 'Accelerator', 'Angel Group', 'Convertible Note', 'Corporate Centure Capital', 'Co-working Space', 'Crowdfunding', 'Debt', 'Early Stage Venture', 'Entrepreneurship Program', 'Family Investment Office', 'Fund of Funds', 'Government Office', 'Grant', 'Hedge Fund', 'Incubator', 'Initial Coin Offering', 'Investment Bank', 'IPO', 'Late Stage Venture', 'Non-Equity Assistance', 'Pension Funds', 'Pre-IPO', 'Post-IPO', 'Secondary Market', 'Secondary Purchaser', 'Startup Competition', 'Syndicate', 'University Program', 'Venture Debt', 'Other', 'Not Selected'],
		sectors: ['General', 'Accounting', 'Advertising', 'Advice', 'Aerospace', 'Ag Tech', 'Analytics', 'Angel Investment', 'Apps', 'Artificial Intelligence', 'Asset Management', 'Banking', 'Big Data', 'Biotechnology', 'Blockchain', 'Business Development', 'Business Information Systems', 'CleanTech', 'Cloud Infrastructure', 'Commerce & Shopping', 'Commercial Real Estate', 'Community & Lifestyle', 'Consumer', 'Consumer Electronics', 'Consumer Goods', 'Consulting', 'Credit', 'Cryptocurrency', 'Customer Service', 'Cybersecurity', 'Data & Analytics', 'Data Management', 'Database', 'Delivery', 'Developer APIs', 'Developer Platform', 'Document Management', 'E-Commerce', 'Education', 'Energy', 'Enterprise Software', 'Environmental Engineering', 'Events', 'Female Focus', 'Finance', 'Financial Services', 'FinTech', 'Food & Beverage', 'Gaming', 'Genetics', 'Government', 'Gov Tech', 'GreenTech', 'Hardware', 'Healthcare', 'Higher Education', 'Impact Investing', 'Information Technology', 'Infrastructure', 'Intellectual Property', 'Internet', 'Internet Services', 'Insurance', 'Insurtech', 'Incubators', 'Law Enforcement', 'Legal', 'Legal Tech', 'Lending & Investments', 'Life Science', 'Machine Learning', 'Management Consulting', 'Manufacturing', 'Marketplace', 'Media & Entertainment', 'Medical', 'Medical Device', 'Mobile', 'Mobile Apps', 'Oil & Gas', 'Payments', 'Privacy & Security', 'Productivity Tools', 'Professional Services', 'Prop Tech', 'Real Estate', 'Retail', 'Risk Management', 'SaaS', 'Sales & Marketing', 'Science & Engineering', 'Smart Cities', 'Software', 'Stock Exchanges', 'Sustainability', 'Tax Consulting', 'Transportation', 'Venture Capital', 'Video', 'Wealth Management', 'Web3', 'Web Development', 'Web Hosting', 'Wellness', 'Wholesale', 'Other', 'Not Selected'],
	};

	let companyKeys = {
		fiveWords: 'Description', companyDescription: 'Detail Box', vatRegCode: 'VAT Code', ukUTRCode: 'UTR Code', cAddress: 'Address Line', cPostalCode: 'Postal Code',
		cCountry: 'Country', cWebsite: 'Website Url', cLinkedin: 'LinkedIn Url', cFacebook: 'Facebook Url', cInstagram: 'Instgram Url', cStage: 'Company Stage',
		job: 'Contact Job Title', email: 'Contact Email', phone: 'Contact Phone', linkedIn: 'Contact LinkedIn', bio: 'Contact Bio',
	};

	let invalidEmails = ['hello@', 'enquiries@', 'pitch@', 'info@', 'contact@', 'support@', 'team@', 'admin@', 'feedback@', 'partnership@', 'inquiries@', 'office@'];
	let ukRegions = ['UK', 'East Midlands', 'West Midlands', 'East of England', 'South East England', 'South West England', 'North West England', 'North East England', 'Yorkshire and the Humber', 'Greater London', 'Scotland', 'Wales', 'Northern Ireland', 'Channel Islands (Jersey & Guernsey)', 'Isle of Man'];

	useEffect(() => {
		if (location.hash) {
			let tab = location.hash.split('#')[1];
			tab = tab.replaceAll('%20', ' ');
			setIndexTab(tab);
		}
	}, [location.hash]);

	useEffect(() => { getInvestorLeadQuestions() }, []);
	useEffect(() => {
		let isCompanySettings = localStorage.getItem("isInvestorSettings");
		if (isCompanySettings == null) {
			// dispatch(toggleModal({ open: 'companySettings' }));
			localStorage.setItem('isInvestorSettings', true);
		}
	}, []);

	useEffect(() => { getAdvisors() }, []);
	const getAdvisors = async () => {
		let response = await getRequest(`/user/getAdvisor`);
		if (response["code"] == 200 && response["body"]) {
			setAdvisors(response["body"]["advisors"]);
			setInvestors(response["body"]["investors"]);
		}
	};

	useEffect(() => { fetchCompany() }, [user.companyId?._id]);
	const fetchCompany = async () => {
		try {
			const res = await getRequest(`/company/get/${user.companyId?._id}?lightweight=false`);
			dispatch(setCompany(res['body']));
		} catch (error) {
			console.error("Error fetching company data:", error);
		}
	}

	const handleSavePreferredContact = async () => {
		if (!selectedContact) return showMessage("Please select a contact to save as preferred contact");
		console.log(companyContact, "companyContact")
		let response = await postRequest(`/company/setPreferredContact`, {
			companyId: isCompanySettings ? companyId : user.companyId._id,
			contactId: selectedContact['_id'],
		});

		if (response && response['code'] === 200) {
			showMessage("Preferred contact saved successfully");
			setIsMainRecipient(true);
		} else {
			showMessage(response.message || "Failed to save preferred contact");
		}
	}

	const handleSetLead = (member) => {
		if (!hasValidAdvisor(member)) {
			return showMessage('Business Card data not complete')
		}
		if (member && member['_id']) {
			setSelectedContact(member);
		}
	}

	useEffect(() => {
		if (user.companyId?._id) {
			setFormData((prevFormData) => ({ ...prevFormData, companyId: user.companyId?._id }));
			fetchInvestorFirmDetails();
			fetchCompany();
			getPromptScore(user.companyId?._id);
		} else if (isCompanySettings) {
			fetchInvestorFirmDetails();
		}
	}, [user.companyId?._id]);

	useEffect(() => {
		setFormData((prevFormData) => ({ ...prevFormData, directorId: director }));
	}, [director]);

	useEffect(() => {
		let tempSectors = [];
		if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector1']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector1'])) tempSectors.push(company['preferredSectors']['sector1']);
		if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector2']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector2'])) tempSectors.push(company['preferredSectors']['sector2']);
		if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector3']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector3'])) tempSectors.push(company['preferredSectors']['sector3']);
		if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector4']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector4'])) tempSectors.push(company['preferredSectors']['sector4']);
		if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector5']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector5'])) tempSectors.push(company['preferredSectors']['sector5']);
		setSelectedSectors(tempSectors);

		if (company && company['preferredContact']) {
			const member = company?.['members']?.find(member => member['_id'] === company['preferredContact']);
			setSelectedContact(member);
		}

		let tempStages = [];
		if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage1']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage1'])) tempStages.push(company['stageFocus']['stage1']);
		if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage2']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage2'])) tempStages.push(company['stageFocus']['stage2']);
		if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage3']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage3'])) tempStages.push(company['stageFocus']['stage3']);
		setSelectedStages(tempStages);

		if (company?.['ukRegions'] && Object.keys(company['ukRegions']).length > 0) setSelectedUKRegions(company['ukRegions']);
	}, [company]);

	const fetchInvestorFirmDetails = async () => {
		const response = await getRequest(`/company/getInvestorFirm/${isCompanySettings ? companyId : user.companyId._id}`);
		if (response && response?.['code'] == 200 && response['body']) {
			let { contact, ...companyWithoutContact } = response.body;
			setCompany(companyWithoutContact);
			setCompanyContact(contact);
		}
	};

	const getPromptScore = async (investorId) => {
		const response = await getRequest(`/company/getPromptScore/${isCompanySettings ? companyId : investorId}`);
		if (response && response['code'] === 200) setPromptScore(response['body']);
	};

	const getInvestorLeadQuestions = async () => {
		const response = await postRequest(`/question/getModuleQuestions`, { type: 'investor-lead' });
		if (response && response['code'] === 200) {
			const sortedQuestions = response['body'].sort((a, b) => {
				const qNoA = a.qNo || '', qNoB = b.qNo || '';
				// Split by dot and compare each part
				const partsA = qNoA.split('.'), partsB = qNoB.split('.');

				for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
					const partA = partsA[i] || '', partB = partsB[i] || '';
					// Try to parse as numbers, if both are numeric compare as numbers
					const numA = parseInt(partA), numB = parseInt(partB);
					if (!isNaN(numA) && !isNaN(numB)) if (numA !== numB) return numA - numB;
					else { if (partA !== partB) return partA.localeCompare(partB) }
				}
				return 0;
			});
			setInvestorLeadQuestions(sortedQuestions);
		}
	};

	const getAuditLogs = async (endpoint) => {
		const response = await postRequest('/log', { endpoint, companyId: company['_id'] });
		if (response && response['code'] == 200) {
			await setAuditLogList(response['body']);
			dispatch(toggleModal({ open: 'auditLogs' }));
		}
	};

	const uploadImage = async () => {
		let attachment = [];
		if (cropper.current && currentImage) {
			let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL()
			let res = await fetch(imageToUpload);
			let blob = await res.blob();
			const coverFile = new File([blob], "profile image", { type: "image/png" });
			attachment.push(coverFile);
			setCurrentImage(imageToUpload);

			if (uploadType == 'advisorLogo') {
				const response = await postRequest(`/company/updateLogo/${company['_id']}`, { attachment });
				if (response || response["code"] == 200) await setAdvisorLogo(response?.['body']?.['logo']);
				setIsImageModal(false);
				showMessage(response.message);
			}
			else {
				const response = await postRequest(`/company/uploadFile`, { attachment }, true);
				if (response || response['code'] == 200) {
					if (uploadType === 'logo') setCompany({ ...company, logo: response?.['body']?.['report']?.['location'] });
					else if (uploadType === 'newContactImage') setNewContact({ ...newContact, profilePicture: response?.['body']?.['report']?.['location'] });

					setSettingsChanged(true);
					setIsImageModal(false);
				}
				showMessage(response.message);
			}
		}
	};

	const handleImage = async (e) => {
		let image = e.target.files[0]
		if (image && image.size > (5 * 1024 * 1024)) return showMessage("Photo Size must be less than 5MB");
		image = await URL.createObjectURL(image);

		setCurrentImage(image);
	};

	const handleContactChange = (event) => {
		const { name, value } = event.target;

		setUpdateSettingsData({ ...updateSettingsData, [name]: value });
		setCompanyContact({ ...companyContact, [name]: value });
	};

	// Regex to validate LinkedIn profile URL
	const linkedInRegex = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?$/;
	const handleNewContactChange = (event) => {
		const { name, value } = event.target;
		if (name && name.toLowerCase() === "linkedin") {
			setIsValid(linkedInRegex.test(e.target.value));
		}
		if (name === 'isMainRecipient') {
			if (isMainRecipient) setIsMainRecipient(!isMainRecipient);
			else {
				if (newContact['firstName'] == '' || newContact['lastName'] == '' || newContact['email'] == '' || newContact['phone'] == '' || newContact['linkedIn'] == '') showMessage('Please complete all fields. Contact can only be added if all fields are completed.');
				else setIsMainRecipient(!isMainRecipient)
			}
		} else setNewContact({ ...newContact, [name]: value });
	};

	const saveSettings = async () => {
		if (invalidEmails.some(invalidEmail => companyContact['email']?.includes(invalidEmail))) {
			showMessage(`Email can not contain "hello@, enquiries@, pitch@, info@, contact@, support@, team@, admin@, feedback@, partnership@, inquiries@, office@ etc."`);
			return;
		}
		if (!isValid) { return showMessage('Enter valid linkedin profile url') }

		let data = { update: updateSettingsData, companyId: company['_id'], action: 'edit', investorId: company['_id'], investorData: company, contactData: companyContact };
		let response = await postRequest(`/company/adminAddEditInvestor`, data);

		if (response && response['code'] === 200) {
			showMessage('Settings saved successfully');
			setUpdateSettingsData({});
			setSettingsChanged(false);
		}
	};

	const saveAnswer = async (e) => {
		let update = { ...company, [e.target.name]: e.target.value };
		updateCompanyData = { ...updateCompanyData, [e.target.name]: e.target.value };

		await setUpdateCompanyData(updateCompanyData);
		setCompany(update);

		let response = await postRequest(`/company/update/${company['_id']}`, { update: updateCompanyData, companyId: company['_id'] });

		if (response && response['code'] === 200) showMessage(response['message']);
	};

	const addNewContact = async () => {
		if (newContact['firstName'] == '' || newContact['lastName'] == '' || newContact['email'] == '') {
			showMessage('Please complete all fields. Contact can only be added if all fields are completed.');
			return;
		}

		let data = {
			firstName: newContact['firstName'],
			lastName: newContact['lastName'],
			email: newContact['email'],
			phone: newContact['phone'],
			linkedIn: newContact['linkedIn'],
			profilePicture: newContact['profilePicture'],
			title: 'Team Member',
			isMainRecipient,
			designation: user?.['designation'] || user?.['title'] || user?.['job'] || '',
			action: 'add',
			permissions: { D001: true, D002: true, D003: true, D004: true, D005: true, D006: true, D007: true, D008: true, D009: true, D010: true, D011: true, D012: true, D013: true, D014: true, D015: true, D016: true, D017: true, D018: true, D019: true, D020: true, DEPF005: true, DEPF006: true, DEPF007: true, DEPN004: true, },
		};

		const response = await postRequest(`/user/addAdvisor`, data);
		if (response && response["code"] == 200) {
			dispatch(toggleModal({ open: '' }));
			showMessage('Contact added successfully');
			setIsMainRecipient(false);
			setNewContact({
				firstName: '',
				lastName: '',
				email: '',
				phone: '',
				profilePicture: '',
				linkedIn: '',
			});
		}
	};

	const handleAnswer = (e, questionType) => {
		const { name, value } = e['target'];

		if (questionType.includes('YN')) setInvestorLeadQuestions(prevQuestions => prevQuestions.map(question => question['_id'] == name ? { ...question, radioOption: value } : question));
		else if (questionType.includes('Multi')) setInvestorLeadQuestions(prevQuestions => prevQuestions.map(question => question['_id'] == name ? { ...question, dropdown: value.join(';') } : question));
		else if (questionType.includes('T')) setInvestorLeadQuestions(prevQuestions => prevQuestions.map(question => question['_id'] == name ? { ...question, comment: value } : question));
		else setInvestorLeadQuestions(prevQuestions => prevQuestions.map(question => question['_id'] == name ? { ...question, dropdown: value } : question));
	};

	const showUploadPopup = (director) => {
		setDirector(director['_id']);
		const matchingDirector = company?.['directors'].find(d => d['_id'] === director['_id']);
		const linkedInValue = (matchingDirector && matchingDirector['linkedIn'] !== 'undefined') ? matchingDirector['linkedIn'] : null;

		setFormData({ ...formData, linkedIn: linkedInValue });
		setDirector(director)
	};

	const confirmDeleteFiles = async () => {
		let questionId = "64bf7e6bacdfbb8c415c2cb4";
		let index = company?.directors.findIndex(el => el['_id'] == director['_id']);
		const directorId = director['_id'];
		const res = await postRequest('/repository/deleteFile', { file: attachment, questionId, companyId: company['_id'], directorId });
		if (res && res['code'] == 200) {
			Object.keys(company.modules).map(module => {
				if (module === `directors-questionnaire_${director['_id']}`) {
					setCompany(company => {
						const updatedCompany = { ...company };
						const moduleObj = updatedCompany.modules[module];
						if (moduleObj && moduleObj.sections[0]?.subFolders[2]?.questions[0]?.answer?.files) {
							moduleObj.sections[0].subFolders[2].questions[0].answer.files = moduleObj.sections[0].subFolders[2].questions[0].answer.files?.filter(file => {
								return file !== attachment;
							});
						}
						return updatedCompany;
					});
				}
			})

			const updatedCvData = { ...cvData };
			if (updatedCvData.hasOwnProperty(directorId)) {
				delete updatedCvData[directorId];
			}
			setCvData(updatedCvData);
			dispatch(toggleModal({ open: '' }));
			showMessage(res.message);
		}
	};

	const closeDirectorPopup = () => {
		dispatch(toggleModal({ open: '' }));
		setFormData({ ...formData, linkedIn: '' });
	};

	const handleSubmitDirector = async () => {
		let data;
		if (attachment) data = { attachment: [attachment], ...formData };
		else data = { ...formData };
		if (formData['linkedIn'].length > 0) {
			const regex = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]{5,30}\/?$/;
			const isValid = regex.test(formData['linkedIn'])
			if (!isValid) {
				return showMessage("Please provide a valid linkedin profile url");
			}
		}

		let res = await postRequest('/question/saveCV', data);
		if (res && res['code'] == 200) {
			const { files, linkedIn } = res['body'];
			const updatedCompanyDirectors = company.directors.map(director => {
				if (director['_id'] == formData.directorId) {
					return { ...director, cv: files[0], linkedIn: linkedIn || formData.linkedIn };
				}
				return director;
			});
			const updatedCompany = { ...company, directors: updatedCompanyDirectors };
			setCompany(updatedCompany);
			await fetchInvestorFirmDetails();
			await fetchCompany();
			closeDirectorPopup();
			showMessage(res['message']);
		}
	};

	const selectIndexTab = (tab) => {
		if (tab == 'InvestorMatch Criteria') setIsInvestorMatchTabs(!isInvestorMatchTabs);
		else setIsInvestorMatchTabs(false);

		if (tab == 'AdvisorMatch') setIsClientMatchTabs(!isClientMatchTabs);
		else setIsClientMatchTabs(false);

		setIndexTab(tab);
		setUpdateCompanyData({});
		setUpdateSettingsData({})
	};

	const auditLogButton = (path) => {
		return <button onClick={() => getAuditLogs(path)} className="cp df jcc px2rem py0-5rem bg5 fs0-75rem fw500 br30px bw1px bo16 bss">
			<span className='bg5 mr1rem w20px h20px df jcc aic'>
				<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z" fill="#4A67FF" />
				</svg>
			</span>
			<span className='c15'>Audit Log</span>
		</button>
	};

	const getSidebarHTML = () => {
		const tabs = user?.['role'] == 'Advisor'
			? ["Companies House Data", "Company Profile", "Director's Information", "Advisor Permissions", "AdvisorMatch"]
			: ["Companies House Data", "Company Profile", "Director's Information", "Investor Permissions", "InvestorMatch Criteria", "Investment Leads", "Preferred Contact For Leads"];
		return (
			<div id="sidebar-company-settings" style={{ width: "calc((100% - 4rem) / 5)" }} className="sidebar-company-settings w100 bsbb dg gg1rem br5px bg0 ps t0 sidebar-report">
				<div className='bg5 br10px py0-5rem mt3rem bw1px bo16 bss' style={{ backgroundColor: '#F0F2FD50', borderColor: '#7385BE650' }}>
					<div className='df jcc aic fdc p0-5rem'>
						<p className="c3 ttu lh1 fs1-25rem fw500 mt0-5rem tac">{user?.['role']} Settings</p>
						<p className="c3 ttu lh1 fs1-25rem fw500 mt0-5rem tac">Index</p>
						<Link to={user?.['role'] == 'Advisor' ? `/advisor-dashboard` : user?.['role'] == 'Investor' ? `/investor-dashboard` : `/dashboard`}
							className="c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 px3rem py0-5rem df aic jcc mt1rem">
							<i className="icon mr0-5rem">
								<svg width="15" height="15" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z" fill="white" stroke="white" stroke-width="0.5" />
									<path d="M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z" fill="white" stroke="white" stroke-width="0.5" />
								</svg>
							</i>
							Back
						</Link>
					</div>
					<div className='mah100 mya oya df fdc jcsb mt2-5rem'>
						{tabs.map((tab, idx) => {
							return <>
								<Link key={idx} to={`#${tab}`} onClick={() => selectIndexTab(tab)}
									className={`bg5 cp w100 df c2 px1rem py0-75rem df jcsb ${tab == indexTab && 'c3'}`}>
									<span className='fs0-75rem tal'>{tab}</span>
									{(tab == 'InvestorMatch Criteria' && isInvestorMatchTabs) && <i class='fa fa-angle-up mr0-5rem' />}
									{(tab == 'InvestorMatch Criteria' && !isInvestorMatchTabs) && <i class='fa fa-angle-down mr0-5rem' />}
									{(tab == 'AdvisorMatch' && isClientMatchTabs) && <i class='fa fa-angle-up mr0-5rem' />}
									{(tab == 'AdvisorMatch' && !isClientMatchTabs) && <i class='fa fa-angle-down mr0-5rem' />}
								</Link>
								{(tab == 'InvestorMatch Criteria' && isInvestorMatchTabs) && investorMatchTabs.map(subTab => {
									return <button className={`bg5 cp df c2 px2rem py0-75rem`}>
										<span className={`fs0-75rem tal c3-hover ${selectedInvestorTab == subTab && 'c3'}`} onClick={() => setSelectedInvestorTab(subTab)}>{subTab}</span>
									</button>
								})}
								{(tab == 'AdvisorMatch' && isClientMatchTabs) && clientMatchTabs.map(subTab => {
									return <button className={`bg5 cp df c2 px2rem py0-75rem`}>
										<span className={`fs0-75rem tal c3-hover ${selectedClientMatchTab == subTab && 'c3'}`} onClick={() => setSelectedClientMatchTab(subTab)}>{subTab}</span>
									</button>
								})}
							</>
						})}
						<hr class='my0-5rem c16' />
						<button onClick={() => dispatch(toggleModal({ open: 'companyDelete' }))} className={`bg5 cp delete-active w100 df px1rem py0-5rem `}>
							<span className='fs0-75rem tal'>Delete Company</span>
						</button>
					</div>
				</div>
				{(indexTab == 'InvestorMatch Criteria' && isInvestorMatchTabs && selectedInvestorTab == 'Investor Details') &&
					<img className='w100 mt1rem' src={require('../../../../../images/investor-settings/sidebar-details-ai.png')} alt="Intelligence" />
				}
				{(indexTab == 'AdvisorMatch' && isClientMatchTabs && selectedClientMatchTab == 'Skills & Experience') &&
					<img className='w100 mt1rem' src={require('../../../../../images/investor-settings/sidebar-skills-experience.png')} alt="Intelligence" />
				}
			</div>
		)
	};

	//********** Companies House Data **********//
	const companiesHouseData = () => {
		const tabs = ["Filing History", "Officers", "Persons with significant control", "Charges", "Registers"];
		return (
			<div className="sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem">
				<div className="pr">
					<div className='df jcsb aic mb1rem'>
						<h4 className="fs1-5rem fw500 c14">COMPANY INFORMATION</h4>
						{auditLogButton(`/company/update/${company['_id']}`)}
					</div>
					<div className="p1-5rem c15 fs0-75rem bw1px bo16 br20px bss mb2rem">
						<div class='df jcsb'>
							<div class='df fdc'>
								<p className="w100 mb0-5rem">Company Status: <b>{company['isActive'] ? 'Active' : '-'}</b></p>
								<p className="w100 mb0-5rem">Company Number: <b>{company['ukRegNo'] ? company['ukRegNo'] : "-"}</b></p>
								<p className="w100 mb0-5rem">Company Title: <b>{company['cName'] ? company['cName'] : "-"}</b></p>
								<p className="w100 mb0-5rem">Company Date of Creation: <b>{company['createdAt'] ? moment(company['createdAt']).format('YYYY-MM-DD') : "-"}</b></p>
								<p className="w100 mb0-5rem">Company Address: <b>{company['cAddress'] ? company['cAddress'] : "-"}</b></p>
								{company['ukRegNo'] && <div className='df mt1rem'>
									<Link to={`https://find-and-update.company-information.service.gov.uk/company/${company['ukRegNo']}`} target='_blank' className='df aic jcc cp bg3 c1 br25px px1-5rem py0-5rem mr1rem fs0-75rem fw500'>
										<img src={require('../../../../../images/companies-core-house-white-logo.png')} className="mr0-5rem" />
										Companies House - Direct
									</Link>
									<Link to={`https://find-and-update.company-information.service.gov.uk/company/${company['ukRegNo']}/more`} target='_blank' className='df aic jcc cp bg3 c1 br25px px1-5rem py0-5rem fs0-75rem fw500'>
										<img src={require('../../../../../images/companies-core-house-white-logo.png')} className="mr0-5rem" />
										View Snapshot
									</Link>
								</div>}
							</div>
							<div class=''><img src={require('../../../../../images/companies-house-text.png')} /></div>
						</div>
					</div>
					<div className='mb2rem'>
						<h4 className="fs1-5rem fw500 c14 mb1rem">COMPANY SNAPSHOT</h4>
						<div class='p1-5rem bw1px bo16 br20px bss'>
							<div className='df jcc'>
								{tabs.map((tab, idx) => {
									return (
										<button key={idx} onClick={() => setTabCompanySnapshot(tab)} className={`cp py0-5rem px1rem bg1 fs1rem ${tab == tabCompanySnapshot ? ' c3 fw600' : 'c12 fw400'}`} style={{ borderBottom: tab == tabCompanySnapshot && '2px solid #6366f1' }}>
											{tab}
										</button>
									)
								})}
							</div>
							{tabCompanySnapshot == "Filing History"
								? <>{filingHistoryTab()}</>
								: tabCompanySnapshot == "Officers"
									? <>{officersTab()}</>
									: tabCompanySnapshot == "Persons with significant control"
										? <>{personsSignificantTab()}</>
										: tabCompanySnapshot == "Charges"
											? <>{chargesTab()}</>
											: <>{registersTab()}</>
							}
						</div>
					</div>
					<div className='mb2rem p1-5rem bw1px bo16 br20px bss'>
						<div class='df jcsb'>
							<h4 className="fs1-125rem fw600 c14 mb1rem">HMRC</h4>
							<img class='mb1rem' src={require('../../../../../images/crown-circle.png')} />
						</div>
						<div className='df'>
							<input
								id="vatRegCode"
								name="vatRegCode"
								onBlur={saveAnswer}
								value={company?.['vatRegCode'] || ''}
								placeholder="Please add VAT reg number"
								className="w100 px1rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem mx0-5rem"
								onChange={(event) => setCompany({ ...company, [event['target']['name']]: event['target']['value'] })}
							/>
							<input
								id="ukUTRCode"
								name="ukUTRCode"
								onBlur={saveAnswer}
								placeholder="Please add UTR number"
								value={company?.['ukUTRCode'] || ''}
								className="w100 px1rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem mx0-5rem"
								onChange={(event) => setCompany({ ...company, [event['target']['name']]: event['target']['value'] })}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	};

	const filingHistoryTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cFiling'] ? Math.ceil(company['cFiling'].length / itemsPerPage) : 0;

		const handleNext = () => { if (filingCurrentPage < totalPages - 1) setFilingCurrentPage(filingCurrentPage + 1) };
		const handlePrev = () => { if (filingCurrentPage > 0) setFilingCurrentPage(filingCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cFiling']) return [];
			let startIndex = filingCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cFiling'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>FILING HISTORY</p>
				{company['cFiling'] && company['cFiling'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((history, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Category: <span className='fw600'>{history['category'] ? history['category'] : 'Officers'}</span>
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="" src={require(`../../../../../images/companies-core-house-logo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">File name: <span className='fw600'>{history['description'] || 'appoint-person-member-limited-liability-partnership-with-appointment-date'}</span></p>
										<p className="mb0-5rem">Bar Code: <span className='fw600'>{history['barcode'] || 'XDZJMW00'}</span></p>
										<p className="mb0-5rem">Transaction ID: <span className='fw600'>{history['transaction_id'] || 'MzQ2MDk4ODY3NGFkaXkzaXF6'}</span></p>
										<p className="mb0-5rem">Date: <span className='fw600'>{history['date'] || '2025-04-01'}</span></p>
									</div>
									{history?.['Location'] &&
										<a href={history['Location']} target='_blank' className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
											<img className="mr0-5rem" src={require(`../../../../../images/companies-core-house-white-logo.png`)} alt="" />
											View Document
										</a>
									}
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${filingCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={filingCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(filingCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={filingCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	const officersTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cOfficers'] ? Math.ceil(company['cOfficers'].length / itemsPerPage) : 0;

		const handleNext = () => { if (officersCurrentPage < totalPages - 1) setOfficersCurrentPage(officersCurrentPage + 1) };
		const handlePrev = () => { if (officersCurrentPage > 0) setOfficersCurrentPage(officersCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cOfficers']) return [];
			let startIndex = officersCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cOfficers'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>OFFICERS</p>
				{company['cOfficers'] && company['cOfficers'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((data, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Role: <span className='fw600'>{data['officer_role'] ? data['officer_role'] : '-'}</span>
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="w70" src={require(`../../../../../images/profile-photo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">Name: <span className='fw600'>{data['name'] ? data['name'] : '-'}</span></p>
										<p className="mb0-5rem">Appointed On: <span className='fw600'>{data['appointed_on'] ? data['appointed_on'] : '-'}</span></p>
										{data['appointment'] && <p className="mb0-5rem">{data['appointment']['type']} Filing: <a href={data['appointment']['Location']} target='_blank' className='c3 fw600'>View Document</a></p>}
										<p className="mb0-5rem">Address: <span className='fw600'>{data['address']
											? <>{data['address']['premises'] && data['address']['premises']}
												{data['address']['address_line_1'] && ', ' + data['address']['address_line_1']}
												{data['address']['address_line_2'] && ', ' + data['address']['address_line_2']}
												{data['address']['locality'] && ' - ' + data['address']['locality']}
												{data['address']['region'] && ', ' + data['address']['region']}
												{data['address']['country'] && ', ' + data['address']['country']}
											</>
											: '-'
										}</span></p>
									</div>
									<button onClick={() => { setOfficersReadMore(data); dispatch(toggleModal({ open: 'officersReadMore' })) }} className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
										<img className="mr0-5rem" src={require(`../../../../../images/companies-core-house-white-logo.png`)} alt="" />
										Read More
									</button>
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${officersCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={officersCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(officersCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={officersCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	const personsSignificantTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cSignificantControl'] ? Math.ceil(company['cSignificantControl'].length / itemsPerPage) : 0;

		const handleNext = () => { if (personsCurrentPage < totalPages - 1) setPersonsCurrentPage(personsCurrentPage + 1) };
		const handlePrev = () => { if (personsCurrentPage > 0) setPersonsCurrentPage(personsCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cSignificantControl']) return [];
			let startIndex = personsCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cSignificantControl'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>PERSONS WITH SIGNIFICANT CONTROL</p>
				{company['cSignificantControl'] && company['cSignificantControl'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((data, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Significant Control
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="" src={require(`../../../../../images/companies-core-house-logo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">Name: <span className='fw600'>{data['name'] ? data['name'] : '-'}</span></p>
										<p className="mb0-5rem">Controls:</p>
										{data['natures_of_control'] && data['natures_of_control'].length > 0
											? <ul className='ml1-5rem mb0-5rem'>{data['natures_of_control'].map((control, idx) => (
												<li key={idx} className='fw600'>{control}</li>
											))}</ul>
											: <span className='fw600'>-</span>
										}
									</div>
									<button onClick={() => { setControlReadMore(data); dispatch(toggleModal({ open: 'controlReadMore' })) }} className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
										<img className="mr0-5rem" src={require(`../../../../../images/companies-core-house-white-logo.png`)} alt="" />
										Read More
									</button>
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${personsCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={personsCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(personsCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={personsCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	const chargesTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cCharges'] ? Math.ceil(company['cCharges'].length / itemsPerPage) : 0;

		const handleNext = () => { if (chargesCurrentPage < totalPages - 1) setChargesCurrentPage(chargesCurrentPage + 1) };
		const handlePrev = () => { if (chargesCurrentPage > 0) setChargesCurrentPage(chargesCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cCharges']) return [];
			let startIndex = chargesCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cCharges'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>CHARGES</p>
				{company['cCharges'] && company['cCharges'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((data, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Status: <span className='fw600'>{data['status'] ? data['status'] : '-'}</span>
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="" src={require(`../../../../../images/companies-core-house-logo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">Persons Entitled: <span className='fw600'>{data['persons_entitled'] ? data['persons_entitled'][0]['name'] : '-'}</span></p>
										<p className="mb0-5rem">Charge Description: <span className='fw600'>{data['classification']['description'] ? data['classification']['description'] : '-'}</span></p>
									</div>
									<button onClick={() => { setChargeReadMore(data); dispatch(toggleModal({ open: 'chargeReadMore' })) }} className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
										<img className="mr0-5rem" src={require(`../../../../../images/companies-core-house-white-logo.png`)} alt="" />
										Read More
									</button>
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${chargesCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={chargesCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(chargesCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={chargesCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	const registersTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cRegisters'] ? Math.ceil(company['cRegisters'].length / itemsPerPage) : 0;

		const handleNext = () => { if (registersCurrentPage < totalPages - 1) setRegistersCurrentPage(registersCurrentPage + 1) };
		const handlePrev = () => { if (registersCurrentPage > 0) setRegistersCurrentPage(registersCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cRegisters']) return [];
			let startIndex = registersCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cRegisters'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>REGISTERS</p>
				{company['cRegisters'] && company['cRegisters'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((data, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Register
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="" src={require(`../../../../../images/companies-core-house-logo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">Name: <span className='fw600'>DE ROOS, Peter Wouter</span></p>
										<p className="mb0-5rem">Occupation: <span className='fw600'>Occupation:</span></p>
										<p className="mb0-5rem">Address: <span className='fw600'>Lidl House, 14 , Kingston Road - Surbiton</span></p>
									</div>
									<button className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
										<img className="mr0-5rem" src={require(`../../../../../images/companies-core-house-white-logo.png`)} alt="" />
										Read More
									</button>
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${registersCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={registersCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(registersCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={registersCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	//********** Company Profile **********//
	const companyProfile = () => {
		return (
			<div className="w80 mx1rem">
				<div className='df jcsb aic mb1rem'>
					<h3 className="c14 fs1-5rem fw500 ttu">{company['cName']}</h3>
					{auditLogButton(`/company/update/${company['_id']}`)}
				</div>
				{/* Address */}
				<h4 className="fs1rem fw400 c15 mb0-5rem">Address</h4>
				<div className='mb1rem'>
					<div className='pr'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M9 0C5.40545 0 2.48108 2.92437 2.48108 6.51888C2.48108 10.9798 8.31487 17.5287 8.56325 17.8053C8.79655 18.0651 9.20387 18.0647 9.43674 17.8053C9.68512 17.5287 15.5189 10.9798 15.5189 6.51888C15.5188 2.92437 12.5945 0 9 0ZM9 16.5139C7.03663 14.1817 3.65502 9.5805 3.65502 6.51895C3.65502 3.57166 6.05274 1.17394 9 1.17394C11.9473 1.17394 14.345 3.57166 14.345 6.51892C14.3449 9.58061 10.9639 14.181 9 16.5139Z" fill="#505050" />
							<path d="M9 3.23926C7.19149 3.23926 5.7202 4.71058 5.7202 6.51909C5.7202 8.3276 7.19152 9.79892 9 9.79892C10.8085 9.79892 12.2798 8.3276 12.2798 6.51909C12.2798 4.71058 10.8085 3.23926 9 3.23926ZM9 8.62498C7.83879 8.62498 6.89414 7.6803 6.89414 6.51909C6.89414 5.35788 7.83882 4.4132 9 4.4132C10.1612 4.4132 11.1059 5.35788 11.1059 6.51909C11.1059 7.6803 10.1612 8.62498 9 8.62498Z" fill="#505050" />
						</svg>
						{editInput == 'cAddress'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['cAddress']} name="cAddress" type="text" placeholder="Address Line" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company?.['cAddress'] || ''} placeholder="Address Line" onFocus={() => setEditInput('cAddress')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
				</div>
				<div className='w100 df mb1-5rem'>
					<div className='w50 pr mr1rem'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 3C7.16421 3 7.5 3.33579 7.5 3.75V6H10.5V3.75C10.5 3.33579 10.8358 3 11.25 3C11.6642 3 12 3.33579 12 3.75V6H14.25C14.6642 6 15 6.33579 15 6.75C15 7.16421 14.6642 7.5 14.25 7.5H12V10.5H14.25C14.6642 10.5 15 10.8358 15 11.25C15 11.6642 14.6642 12 14.25 12H12V14.25C12 14.6642 11.6642 15 11.25 15C10.8358 15 10.5 14.6642 10.5 14.25V12H7.5V14.25C7.5 14.6642 7.16421 15 6.75 15C6.33579 15 6 14.6642 6 14.25V12H3.75C3.33579 12 3 11.6642 3 11.25C3 10.8358 3.33579 10.5 3.75 10.5H6V7.5H3.75C3.33579 7.5 3 7.16421 3 6.75C3 6.33579 3.33579 6 3.75 6H6V3.75C6 3.33579 6.33579 3 6.75 3ZM10.5 10.5V7.5H7.5V10.5H10.5Z" fill="#505050" />
						</svg>
						{editInput == 'cPostalCode'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company['cPostalCode']} name="cPostalCode" type="text" placeholder="Postal Code" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company['cPostalCode'] || ''} placeholder="Postal Code" onFocus={() => setEditInput('cPostalCode')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
					<div className='w50 pr'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M15.3775 1.60232C15.179 1.48669 14.8423 1.32778 14.3885 1.17257C12.5943 0.558914 10.6085 0.558914 8.65143 1.58632C7.10195 2.39934 5.53205 2.39934 4.09686 1.9087C3.96647 1.86413 3.85052 1.82007 3.75001 1.77877V0.749988C3.75001 0.335777 3.4142 0 2.99999 0C2.58578 0 2.25 0.335777 2.25 0.749988V2.25035V9.76384V17.25C2.25 17.6642 2.58578 18 2.99999 18C3.4142 18 3.74998 17.6642 3.74998 17.25V10.8872C5.50758 11.454 7.44152 11.4286 9.34847 10.428C10.8981 9.61492 12.468 9.61492 13.9032 10.1056C14.2567 10.2264 14.5051 10.3436 14.6226 10.412C15.1226 10.7031 15.75 10.3425 15.75 9.76388V2.25039C15.75 1.98348 15.6081 1.73668 15.3775 1.60232ZM14.25 8.64025C12.4924 8.07353 10.5584 8.09919 8.6515 9.09977C7.10191 9.91287 5.53201 9.91287 4.09679 9.42223C3.96647 9.37768 3.85042 9.33363 3.74994 9.29232V3.37402C5.50751 3.94073 7.44152 3.91507 9.34843 2.91449C10.8981 2.10101 12.4679 2.10101 13.903 2.59182C14.0334 2.6364 14.1495 2.68049 14.25 2.72183V8.64025H14.25Z" fill="#505050" />
						</svg>
						{editInput == 'cCountry'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company['cCountry']} name="cCountry" type="text" placeholder="Country" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company['cCountry'] || ''} placeholder="Country" onFocus={() => setEditInput('cCountry')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
				</div>
				{/* Overview */}
				<h4 className="fs1rem fw400 c15 mb0-5rem">Overview <span className="fs0-75rem fw300 c12 fsi">(200 words generated by AI)</span></h4>
				<div className='mb1-5rem'>
					{editInput == 'description'
						? <textarea rows={15} onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company['description'] ? company['description'] : company['companyDescription'] ? company['companyDescription'] : ""} name="description" className="w100 p1rem br5px bw1px bo16 bss c15 fs0-75rem" placeholder="Overview..."></textarea>
						: <div onClick={() => setEditInput('description')} className="w100 p1rem br5px bw1px bo16 bss c15 fs0-75rem">{company['description'] ? company['description'] : company['companyDescription'] ? company['companyDescription'] : ""}</div>
					}
				</div>

				{/* Web & Socials */}
				<h4 className="fs1rem fw400 c15 mb0-5rem">Web & Socials</h4>
				<div className='w100 df mb1-5rem'>
					<div className='w50 pr mr1rem'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M9 1.125C7.44248 1.125 5.91992 1.58686 4.62489 2.45218C3.32985 3.31749 2.32049 4.5474 1.72445 5.98637C1.12841 7.42534 0.972461 9.00874 1.27632 10.5363C1.58018 12.0639 2.3302 13.4671 3.43154 14.5685C4.53288 15.6698 5.93607 16.4198 7.46367 16.7237C8.99127 17.0275 10.5747 16.8716 12.0136 16.2756C13.4526 15.6795 14.6825 14.6702 15.5478 13.3751C16.4131 12.0801 16.875 10.5575 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95469 11.0886 1.125 9 1.125ZM9 15.75C8.29688 15.75 7.38 14.3044 6.96938 11.8125H11.0306C10.62 14.3044 9.70313 15.75 9 15.75ZM6.82875 10.6875C6.77813 10.1587 6.75 9.59625 6.75 9C6.75 8.40375 6.77813 7.84125 6.82875 7.3125H11.1713C11.2219 7.84125 11.25 8.40375 11.25 9C11.25 9.59625 11.2219 10.1587 11.1713 10.6875H6.82875ZM2.25 9C2.25358 8.43063 2.32726 7.86386 2.46938 7.3125H5.70375C5.65313 7.875 5.625 8.4375 5.625 9C5.625 9.5625 5.65313 10.125 5.70375 10.6875H2.46938C2.32726 10.1361 2.25358 9.56937 2.25 9ZM9 2.25C9.70313 2.25 10.62 3.69563 11.0306 6.1875H6.96938C7.38 3.69563 8.29688 2.25 9 2.25ZM12.2963 7.3125H15.5306C15.8232 8.41848 15.8232 9.58152 15.5306 10.6875H12.2963C12.375 10.125 12.375 9.5625 12.375 9C12.375 8.4375 12.375 7.875 12.2963 7.3125ZM15.1088 6.1875H12.1613C11.9947 4.91356 11.5983 3.68044 10.9913 2.54813C11.8964 2.83223 12.732 3.30288 13.4441 3.92972C14.1562 4.55657 14.729 5.32569 15.1256 6.1875H15.1088ZM7.00875 2.54813C6.40171 3.68044 6.00528 4.91356 5.83875 6.1875H2.87438C3.271 5.32569 3.84382 4.55657 4.55593 3.92972C5.26803 3.30288 6.1036 2.83223 7.00875 2.54813ZM2.87438 11.8125H5.83875C6.00528 13.0864 6.40171 14.3196 7.00875 15.4519C6.1036 15.1678 5.26803 14.6971 4.55593 14.0703C3.84382 13.4434 3.271 12.6743 2.87438 11.8125ZM10.9913 15.4519C11.5983 14.3196 11.9947 13.0864 12.1613 11.8125H15.1256C14.729 12.6743 14.1562 13.4434 13.4441 14.0703C12.732 14.6971 11.8964 15.1678 10.9913 15.4519Z" fill="#505050" />
						</svg>
						{editInput == 'cWebsite'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company['cWebsite']} name="cWebsite" type="url" placeholder="Website" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company['cWebsite'] || ''} placeholder="Website" onFocus={() => setEditInput('cWebsite')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
					<div className='w50 pr'>
						<div className='pr'>
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
								<path d="M6.00024 14.2188H3.81274V7.15625H6.00024V14.2188ZM6.21851 4.90613C6.21851 4.19897 5.64478 3.625 4.93799 3.625C4.22852 3.625 3.65625 4.19897 3.65625 4.90613C3.65625 5.61353 4.22852 6.1875 4.93799 6.1875C5.64478 6.1875 6.21851 5.61353 6.21851 4.90613ZM14.1875 10.3333C14.1875 8.43738 13.787 7.03125 11.5723 7.03125C10.5081 7.03125 9.7937 7.56348 9.50208 8.11694H9.5V7.15625H7.375V14.2188H9.5V10.7122C9.5 9.79382 9.73376 8.90417 10.8721 8.90417C11.9949 8.90417 12.0312 9.95435 12.0312 10.7705V14.2188H14.1875V10.3333ZM17 15.125V2.875C17 1.84106 16.1589 1 15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125ZM15.125 2.25C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125Z" fill="#505050" />
							</svg>
							{editInput == 'cLinkedin'
								? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company['cLinkedin']} name="cLinkedin" type="url" placeholder="LinkedIn Url" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
								: <input readOnly value={company['cLinkedin'] || ''} placeholder="LinkedIn Url" onFocus={() => setEditInput('cLinkedin')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							}
						</div>
					</div>
				</div>
				<div className='w100 df mb1-5rem'>
					<div className='w50 pr mr1rem'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125V2.875C17 1.84106 16.1589 1 15.125 1ZM15.75 15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H11.4375V11.1875H13.4384L13.6715 9.25H11.4375V7.15625C11.4375 6.62183 11.8406 6.21875 12.375 6.21875H13.7812V4.40625C13.4111 4.354 12.6971 4.28125 12.375 4.28125C11.6461 4.28125 10.9155 4.58875 10.3706 5.12476C9.8092 5.677 9.5 6.40039 9.5 7.16174V9.25H7.46875V11.1875H9.5V15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125Z" fill="#505050" />
						</svg>
						{editInput == 'cFacebook'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company['cFacebook']} name="cFacebook" type="url" placeholder="Facebook URL" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company['cFacebook'] || ''} placeholder="Facebook URL" onFocus={() => setEditInput('cFacebook')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
					<div className='w50 pr'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M9.15778 17C9.1048 17 9.05182 17 8.99847 16.9998C7.74428 17.0028 6.58542 16.9709 5.45842 16.9023C4.42518 16.8395 3.48203 16.4824 2.73078 15.8699C2.0059 15.2788 1.51088 14.4796 1.25953 13.4947C1.04077 12.6373 1.02918 11.7956 1.01807 10.9816C1.01001 10.3974 1.00171 9.7053 1 9.00144C1.00171 8.29465 1.01001 7.60251 1.01807 7.0184C1.02918 6.20444 1.04077 5.36276 1.25953 4.50521C1.51088 3.52035 2.0059 2.72115 2.73078 2.13009C3.48203 1.51753 4.42518 1.16048 5.45854 1.09761C6.58554 1.02913 7.74464 0.997147 9.00153 1.0002C10.2561 0.997514 11.4146 1.02913 12.5416 1.09761C13.5748 1.16048 14.518 1.51753 15.2692 2.13009C15.9942 2.72115 16.4891 3.52035 16.7405 4.50521C16.9592 5.36264 16.9708 6.20444 16.9819 7.0184C16.99 7.60251 16.9984 8.29465 17 8.99851V9.00144C16.9984 9.7053 16.99 10.3974 16.9819 10.9816C16.9708 11.7955 16.9593 12.6372 16.7405 13.4947C16.4891 14.4796 15.9942 15.2788 15.2692 15.8699C14.518 16.4824 13.5748 16.8395 12.5416 16.9023C11.4623 16.968 10.3536 17 9.15778 17ZM8.99847 15.7498C10.2323 15.7527 11.3651 15.7216 12.4656 15.6547C13.2469 15.6072 13.9243 15.3536 14.4793 14.9011C14.9922 14.4828 15.3455 13.9056 15.5292 13.1857C15.7114 12.4719 15.7219 11.7056 15.732 10.9645C15.7399 10.3843 15.7482 9.697 15.75 8.99998C15.7482 8.30283 15.7399 7.6157 15.732 7.03549C15.7219 6.2944 15.7114 5.52804 15.5292 4.81418C15.3455 4.0942 14.9922 3.51705 14.4793 3.09872C13.9243 2.64632 13.2469 2.39278 12.4656 2.3453C11.3651 2.27828 10.2323 2.2474 9.0014 2.25008C7.76784 2.24715 6.63486 2.27828 5.53435 2.3453C4.75307 2.39278 4.07568 2.64632 3.52073 3.09872C3.00777 3.51705 2.65448 4.0942 2.47076 4.81418C2.28862 5.52804 2.27812 6.29428 2.26799 7.03549C2.26006 7.61619 2.25176 8.30381 2.25005 9.00144C2.25176 9.69602 2.26006 10.3838 2.26799 10.9645C2.27812 11.7056 2.28862 12.4719 2.47076 13.1857C2.65448 13.9056 3.00777 14.4828 3.52073 14.9011C4.07568 15.3535 4.75307 15.6071 5.53435 15.6545C6.63486 15.7216 7.76808 15.7528 8.99847 15.7498ZM8.96869 12.9062C6.8148 12.9062 5.06229 11.1539 5.06229 8.99998C5.06229 6.84604 6.8148 5.09372 8.96869 5.09372C11.1227 5.09372 12.8751 6.84604 12.8751 8.99998C12.8751 11.1539 11.1227 12.9062 8.96869 12.9062ZM8.96869 6.34372C7.50403 6.34372 6.31234 7.53537 6.31234 8.99998C6.31234 10.4646 7.50403 11.6562 8.96869 11.6562C10.4335 11.6562 11.625 10.4646 11.625 8.99998C11.625 7.53537 10.4335 6.34372 8.96869 6.34372ZM13.3126 3.84371C12.7949 3.84371 12.3751 4.26339 12.3751 4.78122C12.3751 5.29904 12.7949 5.71872 13.3126 5.71872C13.8304 5.71872 14.2501 5.29904 14.2501 4.78122C14.2501 4.26339 13.8304 3.84371 13.3126 3.84371Z" fill="#505050" />
						</svg>
						{editInput == 'cInstagram'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company['cInstagram']} name="cInstagram" type="url" placeholder="Instagram URL" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company['cInstagram'] || ''} placeholder="Instagram URL" onFocus={() => setEditInput('cInstagram')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
				</div>

				<button className='cp tac c1 br25px px2rem py0-75rem fw500' style={{ backgroundColor: '#ff7b7b', border: 'none', fontSize: '0.9rem' }}>Save Changes</button>
			</div>
		)
	};

	//********** Director's Information **********//
	const directorsInfo = () => {
		return (
			<div className="p2rem">
				{company['directors'] && company['directors'].length > 0
					? <div className='df fww gap1-5rem'>
						{company['directors'].map((director, idx) => {
							return (
								<div key={idx} className='p2rem bw1px bo16 br30px bss m1rem' style={{ flex: '0 0 calc(44% - 0.75rem)' }}>
									<div className='df jcsb mb1rem'>
										<div className='df aic'>
											<img src={director?.['headShot']?.['location'] || require('../../../../../images/profile-photo.png')} className="w60px h60px br100 mr1rem" />
											<div class='df fdc c15'>
												<p className="w100 fs1rem fw500 c14 mb0-25rem">{director['name'] ? director['name'] : '-'}</p>
												<p className="w100 fs0-75rem fw600">{director['role'] ? director['role'] : 'Director'}</p>
												<p className="w100 fs0-75rem fw400 fsi">{director['designation'] ? director['designation'] : 'llp-designated-member'}</p>
											</div>
										</div>
										<div className='pr'>
											<img src={require('../../../../../images/companies-core-house-logo.png')} className="w80" />
										</div>
									</div>
									<div className=''>
										<TextField
											fullWidth
											placeholder="LinkedIn"
											value={formData['directorId'] === director['_id'] && formData['linkedIn'] ? formData['linkedIn'] : (director['linkedIn'] || '')}
											onFocus={(e) => {
												if (!formData['directorId'] || formData['directorId'] !== director['_id']) {
													setFormData({ linkedIn: director['linkedIn'] || '', companyId: company['_id'], directorId: director['_id'] });
												}
											}}
											onBlur={(e) => { if (formData['linkedIn'] && formData['linkedIn'].length > 0 && formData['linkedIn'] !== director['linkedIn']) handleSubmitDirector(); }}
											onChange={(e) => setFormData({ linkedIn: e.target.value, companyId: company['_id'], directorId: director['_id'] })}
											InputProps={{
												style: { borderRadius: "10px", marginBottom: '8px', fontSize: '14px' },
												startAdornment: (
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
														<path d="M6.00024 14.2188H3.81274V7.15625H6.00024V14.2188ZM6.21851 4.90613C6.21851 4.19897 5.64478 3.625 4.93799 3.625C4.22852 3.625 3.65625 4.19897 3.65625 4.90613C3.65625 5.61353 4.22852 6.1875 4.93799 6.1875C5.64478 6.1875 6.21851 5.61353 6.21851 4.90613ZM14.1875 10.3333C14.1875 8.43738 13.787 7.03125 11.5723 7.03125C10.5081 7.03125 9.7937 7.56348 9.50208 8.11694H9.5V7.15625H7.375V14.2188H9.5V10.7122C9.5 9.79382 9.73376 8.90417 10.8721 8.90417C11.9949 8.90417 12.0312 9.95435 12.0312 10.7705V14.2188H14.1875V10.3333ZM17 15.125V2.875C17 1.84106 16.1589 1 15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125ZM15.125 2.25C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125Z" fill="#505050" />
													</svg>
												),
											}}
										/>
									</div>
									<div className='df aic h10'>
										{director?.['cv'] && <>
											<i class="fa fa-circle c4" style={{ fontSize: '10px' }} aria-hidden="true" />
											<a target="_blank" href={director['cv']?.['location']} className="c3 fs0-75rem fw500 tdu">
												<span className="px0-5rem">{director['cv']?.['originalname']}</span>
											</a>
										</>}
									</div>
									{/* <div class='w100 df mt0-5rem'> */}
									<button onClick={() => { showUploadPopup(director); dispatch(toggleModal({ open: 'uploadCvData' })) }} className='df aic jcc cp bg3 c1 br10px px2rem py0-5rem my1rem fw500'>
										<svg class='mr0-75rem' width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g clip-path="url(#clip0_2183_912)">
												<path d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z" fill="white" />
												<path d="M11.4914 17.7883C10.4699 17.7883 9.44852 17.7883 8.4273 17.7883C7.02663 17.7883 6.01589 16.7811 6.0087 15.3809C6.00601 14.8922 6.00601 14.4033 6.0087 13.9142C6.0114 13.4102 6.31687 13.0859 6.78406 13.085C7.25124 13.0841 7.56076 13.4062 7.5639 13.9097C7.56704 14.4133 7.5639 14.9052 7.5639 15.4029C7.56749 15.9249 7.87431 16.229 8.3981 16.2295C10.4672 16.2295 12.5362 16.2295 14.605 16.2295C15.1292 16.2295 15.4365 15.9249 15.4405 15.4034C15.4441 14.9056 15.4405 14.4079 15.4405 13.9102C15.4405 13.4124 15.7509 13.0841 16.2199 13.085C16.6889 13.0859 16.9988 13.4102 16.9948 13.9138C16.9899 14.5503 17.0253 15.1936 16.9454 15.8216C16.7989 16.9707 15.8192 17.782 14.6566 17.7874C13.6041 17.7905 12.5475 17.7883 11.4914 17.7883Z" fill="#4A67FF" />
												<path d="M10.726 7.89412C10.6074 8.00463 10.5377 8.06527 10.473 8.13041C9.97531 8.63309 9.48027 9.13891 8.98029 9.63978C8.62541 9.99557 8.13082 10.0216 7.81008 9.71031C7.48934 9.399 7.50192 8.88824 7.85096 8.53695C8.86709 7.51453 9.88652 6.4957 10.9092 5.48047C11.2686 5.12109 11.7385 5.12109 12.0979 5.48047C13.1275 6.50169 14.1529 7.52726 15.1741 8.55717C15.5101 8.89633 15.5119 9.40619 15.1997 9.71076C14.8875 10.0153 14.3911 10.0019 14.0484 9.6618C13.5408 9.15643 13.0408 8.64297 12.5368 8.13445C12.4716 8.06887 12.402 8.00777 12.2982 7.90984C12.2915 8.0509 12.2834 8.14209 12.2834 8.23328C12.2834 9.84104 12.2856 11.4483 12.2834 13.0561C12.2834 13.6594 11.7524 14.0183 11.2003 13.8036C10.8949 13.6846 10.7291 13.4195 10.7291 13.0314C10.7273 11.4412 10.7273 9.85107 10.7291 8.26113L10.726 7.89412Z" fill="#4A67FF" />
											</g>
											<defs><clipPath id="clip0_2183_912"><rect width="23" height="23" fill="white" /></clipPath></defs>
										</svg>
										Upload CV
									</button>
									{/* </div> */}
								</div>
							)
						})}
					</div>
					: <h2 className="c14 w100 mt2rem tac fs1-25rem">This company has no directors!</h2>
				}
			</div>
		)
	};

	//********** Investor/Advisor Permissions **********//
	const permissionsTab = () => {
		return (
			<div className="p1rem fs1rem mt2rem">
				<h3 class='c14 fs1-25rem mb1rem'>Stage of development:</h3>
				{[{ qNo: 'D017.1', title: 'Accountants' }, { qNo: 'D017.2', title: 'Lawyers' }, { qNo: 'D017.3', title: 'Intellectual Property Advisors' }, { qNo: 'D017.4', title: 'Property Advisors' }, { qNo: 'D017.5', title: 'PR & Media Advisors' }, { qNo: 'D017.6', title: 'Corporate Finance Advisors' },
				{ qNo: 'D017.7', title: 'Commercial Bankers' }, { qNo: 'D017.8', title: 'Investment Bankers' }, { qNo: 'D017.9', title: 'Insurance Brokers' }, { qNo: 'D017.10', title: 'GDPR Advisors' }, { qNo: 'D017.11', title: 'Registrars' }, { qNo: 'D017.12', title: 'Corporate Brokers' }, { qNo: 'D017.13', title: 'Other' },].map(item => {
					return <>
						<div className='df aic jcsb mt1-5rem w80'>
							<div className='mr1rem w70'>
								<p class='c15 fs1rem'>{item['qNo']} <b>{item['title']}</b></p>
								<div className="df mt0-5rem">
									<input type="url" placeholder="Web site url" className="w50 bss bw1px bo16 br10px p1rem mr1rem" />
									<input type="email" placeholder="Email of contact" className="w50 bss bw1px bo16 br10px p1rem" />
								</div>
							</div>
							<div class='df jce w30'>
								<label for={item['qNo']} className="df cp fs0-75rem">
									<span className="checkbox w30px h30px pr">
										<input name={item['title']} id={item['qNo']} className="bg1 bo12 bw1px bss cp td250 w30px h30px br5px" type="radio" />
									</span>
								</label>
							</div>
						</div>
						<hr class='db w80 mt1rem bg16' style={{ border: "none", height: "1px" }} />
					</>
				})}
			</div>
		)
	};

	//********** Our Funds Preferred Investment Criteria **********//
	const investmentLeads = () => {
		return (
			<div className="p1rem pr mx1rem">
				<div className="br5px dg gg0-5rem mb1rem">
					<div className='w100 df jcc aic'>
						{['Standard Questions', 'Bespoked Questions'].map(item => {
							return <button onClick={() => setLeadSectionActive(item)} className={`cp py0-5rem px1rem bg1 fs1rem ${item == leadSectionActive ? ' c3 fw600' : 'c12 fw400'}`} style={{ borderBottom: item == leadSectionActive && '2px solid #6366f1' }}>{item}</button>
						})}
					</div>
					{/********* Standard Questions **********/}
					{leadSectionActive == 'Standard Questions' && <>
						<h3 className='c15 fs1rem mt2rem mb0-5rem'>STANDARD INVESTMENT APPLICANT QUESTIONS</h3>
						<div className="bss bw1px bo5 br10px p1-5rem c15 fs1rem">
							<div className="dg">
								{investorLeadQuestions && investorLeadQuestions.map(question => (
									<div data-module-type={question['type']} data-section-no={question['qNo']} data-question-id={question['_id']} className="bss bw2px bo5 br10px px2rem py1rem mb1rem question-box">
										<div className="df fww pr w100 bsbb aic">
											<span className="tooltip-area-custom cp" style={{ top: '-22px', right: '-25px' }}>
												<i className="icon">
													<img className="h2rem" src={require(`../../../../../images/info-icon.svg`)} alt="" />
													<div className="overlay-box" style={{ left: '-380px', top: '0', right: 'auto' }}>
														<p className="fs0-75rem c6">Please toggle to include/exclude questions from your applicant lead qualification checklist. Please remember that the longer/more difficult the checklist, the less likely applicant companies are to complete it!</p>
													</div>
												</i>
											</span>
											<div className='w70 pr1rem'>
												<div className='mb2rem'>
													<p className="fs1rem"><b>{question['qNo']} </b>{question['qDescription']}</p>
													{question['questionType'].includes('YN') &&
														<div className="df aic fww">
															{['Yes', 'No', 'N/A'].map((option, idx) =>
																<label key={idx} for={question['_id'] + option} className="df cp fs0-75rem py1rem">
																	<span className="checkbox w20px h20px pr">
																		<input
																			id={question['_id'] + option}
																			name={question['_id']}
																			type="radio"
																			className="bg1 bo4 bw1px bss cp td250 w20px h20px br5px"
																			data-option={option}
																			defaultChecked={question['radioOption'] == option}
																			onChange={(e) => handleAnswer(e, question['questionType'])}
																		/>
																	</span>
																	<span className="w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500">{option}</span>
																</label>)
															}
														</div>
													}
													{question['questionType'].includes('DropDown') &&
														<div className="w50 oyh td250 pr mt1rem">
															<select name={question['_id']} value={question['dropdown'] || ''} onChange={(e) => handleAnswer(e, question['questionType'])} className="pl1rem bss bw1px bo16 w100 br20px p1rem">
																{question['dropdown'] && <option value={question['dropdown']} selected disabled hidden>{question['dropdown']}</option>}
																{question['options'] && question['options'].map((option, idx) => <option key={idx} value={option['name'].replaceAll("'", ',')}>{option['name'].replaceAll("'", ',')}</option>)}
															</select>
														</div>
													}
													{question['questionType'].includes('Radio') &&
														<div className="df aic fww">
															{question['options'].map((option, idx) =>
																<label key={idx} for={question['_id'] + option['name']} className="df cp fs0-75rem py1rem">
																	<span className="checkbox w20px h20px pr">
																		<input
																			id={question['_id'] + option['name']}
																			name={question['_id']}
																			type="radio"
																			className="bg1 bo4 bw1px bss cp td250 w20px h20px br5px"
																			data-option={option['name']}
																			defaultChecked={question['dropdown'] == option['name']}
																			onChange={(e) => handleAnswer(e, question['questionType'])}
																		/>
																	</span>
																	<span className="w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500">{option['name']}</span>
																</label>)
															}
														</div>
													}
													{question?.questionType.includes('Multi') &&
														<div className="multi-dropdown mt1rem">
															<Select
																id="demo-multiple-checkbox"
																name={question['_id']}
																labelId="demo-multiple-checkbox-label"
																multiple
																className="w400px"
																placeholder="Select any options from dropdown"
																onChange={(e) => handleAnswer(e, question['questionType'])}
																renderValue={(selected) => selected.join(', ')}
																value={question['dropdown'] ? question['dropdown'].split(";") : []}>
																{question['options'].map((option, idx) => (
																	<MenuItem value={option['name']} className="multi-dropdown-list">
																		<Checkbox checked={question['dropdown']?.split(";").indexOf(option['name']) > -1} />
																		<ListItemText primary={option['name']} />
																	</MenuItem>
																))}
															</Select>
														</div>
													}
													{question['questionType'] == 'T' &&
														<div className="w80 oyh td250 pr mt1rem">
															<textarea
																rows="3"
																name={question['_id']}
																type="text"
																style={{ resize: "vertical" }}
																className="pl1-5rem bss bw1px bo16 w100 br15px p1rem"
																placeholder='Any notes you wish to add'
																defaultValue={question['comment']}
																onBlur={(e) => handleAnswer(e, question['questionType'])}
															></textarea>
														</div>
													}
												</div>
											</div>
											<div className='w30 pl1rem'>
												<div className="pr tae mb6rem"><Switch className="success" defaultChecked={true} /></div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</>
					}
					{/********** Bespoked Questions **********/}
					{leadSectionActive == 'Bespoked Questions' && <>
						<h3 className='c15 fs1rem mt2rem'>BESPOKE INVESTMENT APPLICANT QUESTIONS</h3>
						{['Question 1', 'Question 2', 'Question 3'].map(item => {
							return (
								<div className="bss bw1px bo16 br10px p1-5rem px1rem mb1rem">
									<div className="df fww pr w100 bsbb aic">
										<span className="tooltip-area-custom cp" style={{ top: '-30px', right: '-30px' }}>
											<i className="icon">
												<img className="h2rem" src={require(`../../../../../images/info-icon.svg`)} alt="" />
												<div className="overlay-box" style={{ left: '-380px', top: '0', right: 'auto' }}>
													<p className="fs0-75rem c6">Please toggle to include/exclude questions from your applicant lead qualification checklist. Please remember that the longer/more difficult the checklist, the less likely applicant companies are to complete it!</p>
												</div>
											</i>
										</span>
										<div className='w70 pr1rem c15'>
											<div className='mb1rem'>
												<p className="fs1rem fw500">{item}:</p>
												<input name="input-text" type="text" placeholder="Write question in your own words" className="w100 bss bw1px br10px bo16 p1rem my1rem" />
												<div className="df aic fww ">
													{['Checkbox', 'Multiline', 'Radio', 'Dropdowns', 'Text'].map(option => {
														return (
															<label for={option} className="df cp fs0-75rem">
																<span className="checkbox w30px h30px pr">
																	<input data-option={option} name='option' id={option} className="bg1 bo16 bw1px bss cp td250 w30px h30px br5px" type="radio" checked="" />
																</span>
																<span className="w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500">{option}</span>
															</label>
														)
													})}
												</div>
											</div>
											<input name="input-text" type="text" placeholder="Insert desired answer from company" className="w100 bss bw1px br10px bo16 p1rem" />
										</div>
										<div className='w30 pl1rem'>
											<div className="pr tae mb6rem"><Switch className="success" defaultChecked={true} /></div>
										</div>
									</div>
								</div>
							)
						})}
					</>}
				</div>
			</div>
		)
	};

	//********** Preferred Contact for Leads **********//
	const preferredContactForLeads = () => {
		return (
			<div className="sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem">
				<div className='df jcsb'>
					<h3 className="company-name fs1-25rem">{company['cName']}</h3>
					{auditLogButton(`/company/addEditDeleteInvestor`)}
				</div>
				<div className="br5px dg gg0-5rem my1rem mb1rem invest-box-funds mt2rem">
					<div className='df jcsb aic mt1rem mb1rem'>
						<div className='user-info'>
							<div className='img-box'>
								<img className="w6rem h6rem pr br100 mb0-5ren" src={(selectedContact || companyContact)?.['profile'] || require(`../../../../../images/profile-photo.jpeg`)} alt="TODO" />
							</div>
							<div className='text-box'>
								<h4 className='df fs1-25rem'>
									<p>{(selectedContact || companyContact)?.['firstName'] ? (selectedContact || companyContact)?.['firstName'] : ''} {(selectedContact || companyContact)?.['lastName'] ? (selectedContact || companyContact)?.['lastName'] : ''}</p>
									{(selectedContact || companyContact)?.['linkedIn'] && (
										<a href={(selectedContact || companyContact)?.['linkedIn'].includes('https') ? (selectedContact || companyContact)?.['linkedIn'] : `https://${(selectedContact || companyContact)?.['linkedIn']}`} target='_blank' className="icon ml0-5rem bg1 cp" style={{ width: '15px' }}>
											<i id="icon"><svg version="1.1" className="f3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 310">
												<g>
													<path d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
													C77.16,101.969,74.922,99.73,72.16,99.73z"/>
													<path d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
													c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"/>
													<path d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
													c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
													c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
													C310,145.43,300.549,94.761,230.454,94.761z"/>
												</g>
											</svg></i>
										</a>
									)}
								</h4>
								<div className='group-inputs'>
									{editInput == 'job' ? (
										<p className='df tac p0rem fs1rem c4 fw600'>
											<input
												name="job"
												type="text"
												className="c2"
												defaultValue={(selectedContact || companyContact)?.['job'] || (selectedContact || companyContact)?.['title']}
												placeholder="Enter job title"
												onBlur={() => { saveSettings(), setEditInput(null) }}
												onChange={(event) => handleContactChange(event)}
											/>
										</p>
									) : (
										<p className='fs1rem c4 fw600'>
											{(selectedContact || companyContact)?.['job'] ? (selectedContact || companyContact)?.['job'] : (selectedContact || companyContact)?.['title'] ? (selectedContact || companyContact)?.['title'] : ''}
										</p>
									)}
								</div>
							</div>
						</div>
						<div className='progress-area progress-dashboard' style={{ display: 'flex', position: 'relative', justifyContent: 'center' }}>
							<div className='progress-box'>
								<div className="progress-bar" style={{ width: 50, height: 50 }}>
									<CircularProgressbar
										className={`${promptScore > 67 ? 'green' : promptScore > 33 ? 'orange' : 'red'}`}
										value={promptScore || 0}
										text={`${promptScore || 0}%`}
										styles={buildStyles({
											strokeLinecap: 'round',
											strokeWidth: '5px',
											textSize: '20px',
											pathTransitionDuration: 0.5,
											trailColor: '#d6d6d6',
											backgroundColor: '#fc7785',
											dominantBaseline: 'ideographic',
										})}
									/>
								</div>
								<span style={{ marginBottom: '0', fontSize: '11px' }} className="text-center-area">Prompt Response Score</span>
							</div>
						</div>
						<div className='content-area'>
							<ul className="right-list">
								<li>
									<span className='fs14px' style={{ width: '50px', fontWeight: 600 }}>Email:</span>
									<span>
										<div className='group-inputs'>
											{editInput == 'email' ? (
												<p className='df tac p0rem'>
													<input
														name="email"
														type="text"
														className="c2"
														defaultValue={(selectedContact || companyContact)?.['email']}
														placeholder="Enter email"
														onBlur={() => { saveSettings(), setEditInput(null) }}
														onChange={(event) => handleContactChange(event)}
													/>
												</p>
											) : (
												<p className='ml0-5rem df jcfe' style={{ display: 'flex' }}>
													{(selectedContact || companyContact)?.['email']}
												</p>
											)}
										</div>
									</span>
								</li>
								<li>
									<span className='fs14px' style={{ width: '50px', fontWeight: 600 }}>Tel:</span>
									<span>
										<div className='group-inputs'>
											{editInput == 'phone' ? (
												<p className='df tac p0rem'>
													<input
														name="phone"
														type="text"
														className="c2"
														defaultValue={(selectedContact || companyContact)?.['phone']}
														placeholder="Enter telephone number"
														onBlur={() => { saveSettings(), setEditInput(null) }}
														onChange={(event) => handleContactChange(event)}
													/>
												</p>
											) : (
												<p className='ml0-5rem df jcfe' style={{ display: 'flex' }}>
													{(selectedContact || companyContact)?.['phone']}
												</p>
											)}
										</div>
									</span>
								</li>
								{
									((selectedContact || companyContact)?.['linkedIn'] && (selectedContact || companyContact)?.['linkedIn'] !== "") && <li>
										<span className='fs14px' style={{ width: '50px', fontWeight: 600 }}>LinkedIn:</span>
										<span>
											<div className='group-inputs'>
												{editInput == 'linkedIn' ? (
													<p className='df tac p0rem'>
														<input
															name="linkedIn"
															type="text"
															className="c2"
															defaultValue={(selectedContact || companyContact)?.['linkedIn']}
															placeholder="Enter linkedIn Profile"
															onBlur={() => { saveSettings(), setEditInput(null) }}
															onChange={(event) => handleContactChange(event)}
														/>
													</p>
												) : (
													<p className='cp tdu c3-hover ml0-5rem df jcfe' style={{ display: 'flex' }}>
														{(selectedContact || companyContact)?.['linkedIn'] && (
															<a className='link-area' href={(selectedContact || companyContact)?.['linkedIn'].includes('https') ? (selectedContact || companyContact)?.['linkedIn'] : `https://${(selectedContact || companyContact)?.['linkedIn']}`} target='_blank'>
																{(selectedContact || companyContact)?.['linkedIn'].length > 24 ? `${(selectedContact || companyContact)?.['linkedIn'].slice(0, 24)}...` : (selectedContact || companyContact)?.['linkedIn']}
															</a>
														)}
													</p>
												)}
											</div>
										</span>
									</li>
								}

							</ul>
						</div>
					</div>
					<h3>Investor Bio</h3>
					<div className='group-inputs'>
						{editInput == 'bio' ? (
							<p className='df tac p0rem' style={{ border: '1px solid #eaeaea', borderRadius: '12px', padding: '12px' }}>
								<textarea
									rows={5}
									name="bio"
									type="text"
									className="c2"
									defaultValue={(selectedContact || companyContact)?.['bio']}
									placeholder="Enter bio"
									onBlur={() => { saveSettings(), setEditInput(null) }}
									onChange={(event) => handleContactChange(event)}
								/>
							</p>
						) : (
							<p onClick={() => setEditInput('bio')} style={{ borderBottom: '1px solid #eaeaea', paddingBottom: '12px' }}>
								{(selectedContact || companyContact)?.['bio'] || 'Enter bio here...'}
							</p>
						)}
					</div>

					<div className='table-container bg1 bo5 bw2px bss br10px p1rem mt1rem'>

						{/* Table Header */}
						<div className='table-header df aic py1rem px0-5rem mb1rem'>
							<div className='w25 tal fs0-875rem fw600 c15'>Name</div>
							<div className='w25 tal fs0-875rem fw600 c15'>Email</div>
							<div className='w20 tal fs0-875rem fw600 c15'>Phone</div>
							<div className='w20 tal fs0-875rem fw600 c15'>Business Card</div>
							<div className='w20 tal fs0-875rem fw600 c15'>Role</div>
							<div className='w10 tac fs0-875rem fw600 c15'>Contact</div>
						</div>

						{/* Table Rows */}
						<div className='table-body'>
							{
								company['members'] && company['members'].length > 0 ? company['members'].map((member, index) => {
									return (
										<div key={member['_id']} className={`table-row df aic py1rem px0-5rem mb0-5rem bg1`} style={{ transition: 'background-color 0.2s' }}>
											{/* Name Column */}
											<div className='w25 df aic'>
												{
													member?.['profile']
														? <img className="w3rem h3rem br100 bo5 bw2px bss new-shadow" src={member['profile']} alt="" />
														: <span className='w3rem h3rem df jcc aic br100 bg16 new-shadow c15 fs0-875rem fw600'>
															{member?.['firstName'] ? (member?.['firstName']?.[0] + (member?.['lastName'] ? member?.['lastName']?.[0] : "")) : "?"}
														</span>
												}
												<h5 className='fs0-875rem fw600 c15 mb0-25rem ml0-5rem'>
													{member?.['firstName'] ? (member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : "")) : "Unknown"}
												</h5>
											</div>

											{/* Email Column */}
											<div className='w25'>
												<span className="fs0-75rem c15">
													{member['email'] || 'N/A'}
												</span>
											</div>

											{/* Phone Column */}
											<div className='w20'>
												<span className="fs0-75rem c15">
													{member['phone'] || member['phoneNumber'] || 'N/A'}
												</span>
											</div>

											<div className='w20'>
												{hasValidAdvisor(member) ? <svg xmlns="http://www.w3.org/2000/svg" width="45" height="43" viewBox="0 0 45 43" fill="none">
													<path d="M30.0807 5H7.91406C4.63656 5 1.97656 7.66 1.97656 10.9375V26.7708C1.97656 30.0483 4.63656 32.7083 7.91406 32.7083H30.0807C33.3582 32.7083 36.0182 30.0483 36.0182 26.7708V10.9375C36.0182 7.66 33.3582 5 30.0807 5ZM33.6432 26.7708C33.6432 28.7342 32.0441 30.3333 30.0807 30.3333H7.91406C5.95073 30.3333 4.35156 28.7342 4.35156 26.7708V10.9375C4.35156 8.97417 5.95073 7.375 7.91406 7.375H30.0807C32.0441 7.375 33.6432 8.97417 33.6432 10.9375V26.7708ZM17.4457 20.2C18.1582 19.4242 18.6016 18.395 18.6016 17.2708C18.6016 14.8642 16.6541 12.9167 14.2474 12.9167C11.8407 12.9167 9.89323 14.8642 9.89323 17.2708C9.89323 18.395 10.3366 19.4242 11.0491 20.2C9.95656 20.8967 9.10156 21.9417 8.65823 23.2242C8.4524 23.8417 8.76906 24.5225 9.4024 24.7283C10.0199 24.9342 10.7007 24.6017 10.9066 23.9842C11.3974 22.575 12.7274 21.625 14.2474 21.625C15.7674 21.625 17.1132 22.575 17.5882 23.9842C17.7624 24.475 18.2216 24.7917 18.7124 24.7917C18.8391 24.7917 18.9657 24.7758 19.0924 24.7283C19.7099 24.5225 20.0424 23.8417 19.8366 23.2242C19.3932 21.9417 18.5382 20.8967 17.4457 20.2ZM12.2682 17.2708C12.2682 16.1783 13.1549 15.2917 14.2474 15.2917C15.3399 15.2917 16.2266 16.1783 16.2266 17.2708C16.2266 18.3633 15.3399 19.25 14.2474 19.25C13.1549 19.25 12.2682 18.3633 12.2682 17.2708ZM29.6849 15.6875C29.6849 16.3367 29.1466 16.875 28.4974 16.875H23.7474C23.0982 16.875 22.5599 16.3367 22.5599 15.6875C22.5599 15.0383 23.0982 14.5 23.7474 14.5H28.4974C29.1466 14.5 29.6849 15.0383 29.6849 15.6875ZM29.6849 22.0208C29.6849 22.67 29.1466 23.2083 28.4974 23.2083H23.7474C23.0982 23.2083 22.5599 22.67 22.5599 22.0208C22.5599 21.3717 23.0982 20.8333 23.7474 20.8333H28.4974C29.1466 20.8333 29.6849 21.3717 29.6849 22.0208Z" fill="#151313" />
													<circle cx="32.5" cy="29.5" r="9.5" fill="white" />
													<path d="M33 19C27.5 19 23 23.5 23 29C23 34.5 27.5 39 33 39C38.5 39 43 34.5 43 29C43 23.5 38.5 19 33 19ZM37.3 26.6L32.7 32.6C32.5 32.8 32.2 33 31.9 33C31.6 33 31.3 32.9 31.1 32.6L28.7 29.5C28.4 29.1 28.4 28.4 28.9 28.1C29.4 27.8 30 27.8 30.3 28.3L31.9 30.4L35.7 25.4C36 25 36.7 24.9 37.1 25.2C37.6 25.5 37.6 26.1 37.3 26.6Z" fill="#02BC7D" />
												</svg> : <svg xmlns="http://www.w3.org/2000/svg" width="44" height="42" viewBox="0 0 44 42" fill="none">
													<path d="M30.0834 5.14648H7.91669C4.63919 5.14648 1.97919 7.80648 1.97919 11.084V26.9173C1.97919 30.1948 4.63919 32.8548 7.91669 32.8548H30.0834C33.3609 32.8548 36.0209 30.1948 36.0209 26.9173V11.084C36.0209 7.80648 33.3609 5.14648 30.0834 5.14648ZM33.6459 26.9173C33.6459 28.8807 32.0467 30.4798 30.0834 30.4798H7.91669C5.95335 30.4798 4.35419 28.8807 4.35419 26.9173V11.084C4.35419 9.12065 5.95335 7.52148 7.91669 7.52148H30.0834C32.0467 7.52148 33.6459 9.12065 33.6459 11.084V26.9173ZM17.4484 20.3465C18.1609 19.5707 18.6042 18.5415 18.6042 17.4173C18.6042 15.0107 16.6567 13.0632 14.25 13.0632C11.8434 13.0632 9.89585 15.0107 9.89585 17.4173C9.89585 18.5415 10.3392 19.5707 11.0517 20.3465C9.95919 21.0432 9.10419 22.0882 8.66085 23.3707C8.45502 23.9882 8.77169 24.669 9.40502 24.8748C10.0225 25.0807 10.7034 24.7482 10.9092 24.1307C11.4 22.7215 12.73 21.7715 14.25 21.7715C15.77 21.7715 17.1159 22.7215 17.5909 24.1307C17.765 24.6215 18.2242 24.9382 18.715 24.9382C18.8417 24.9382 18.9684 24.9223 19.095 24.8748C19.7125 24.669 20.045 23.9882 19.8392 23.3707C19.3959 22.0882 18.5409 21.0432 17.4484 20.3465ZM12.2709 17.4173C12.2709 16.3248 13.1575 15.4382 14.25 15.4382C15.3425 15.4382 16.2292 16.3248 16.2292 17.4173C16.2292 18.5098 15.3425 19.3965 14.25 19.3965C13.1575 19.3965 12.2709 18.5098 12.2709 17.4173ZM29.6875 15.834C29.6875 16.4832 29.1492 17.0215 28.5 17.0215H23.75C23.1009 17.0215 22.5625 16.4832 22.5625 15.834C22.5625 15.1848 23.1009 14.6465 23.75 14.6465H28.5C29.1492 14.6465 29.6875 15.1848 29.6875 15.834ZM29.6875 22.1673C29.6875 22.8165 29.1492 23.3548 28.5 23.3548H23.75C23.1009 23.3548 22.5625 22.8165 22.5625 22.1673C22.5625 21.5182 23.1009 20.9798 23.75 20.9798H28.5C29.1492 20.9798 29.6875 21.5182 29.6875 22.1673Z" fill="#151313" />
													<circle cx="31.5" cy="30.5" r="9.5" fill="white" />
													<g clip-path="url(#clip0_2434_60524)">
														<path d="M32 20C26.4858 20 22 24.4858 22 30C22 35.5142 26.4858 40 32 40C37.5142 40 42 35.5142 42 30C42 24.4858 37.5142 20 32 20Z" fill="#F14D4D" />
														<path d="M35.6826 32.5033C36.0083 32.8292 36.0083 33.3558 35.6826 33.6817C35.5201 33.8442 35.3067 33.9259 35.0933 33.9259C34.88 33.9259 34.6666 33.8442 34.5041 33.6817L32 31.1774L29.4959 33.6817C29.3334 33.8442 29.1201 33.9259 28.9067 33.9259C28.6933 33.9259 28.48 33.8442 28.3175 33.6817C27.9917 33.3558 27.9917 32.8292 28.3175 32.5033L30.8217 29.9992L28.3175 27.495C27.9917 27.1691 27.9917 26.6425 28.3175 26.3166C28.6434 25.9908 29.17 25.9908 29.4959 26.3166L32 28.8209L34.5041 26.3166C34.8301 25.9908 35.3566 25.9908 35.6826 26.3166C36.0083 26.6425 36.0083 27.1691 35.6826 27.495L33.1783 29.9992L35.6826 32.5033Z" fill="#FAFAFA" />
													</g>
													<defs>
														<clipPath id="clip0_2434_60524">
															<rect width="20" height="20" fill="white" transform="translate(22 20)" />
														</clipPath>
													</defs>
												</svg>}
											</div>

											{/* Role Column */}
											<div className='w20'>
												<span className={`fs0-75rem pr0-75rem py0-25rem br20px c15`}>
													{(member['role'] && `${member['role']} ${member['_id'] === company['creatorId']['_id'] ? 'Owner' : ''}`) || member['designation'] || member['title'] || member['job'] || 'Member'}
												</span>
											</div>

											{/* Radio Button Column */}
											<div className='w10 tac'>
												<label className={`cp df jcc ${(!hasValidAdvisor(member) && member['_id'] !== company['creatorId']['_id']) && 'op50'}`}>
													<input
														type='radio'
														name='preferredContact'
														value={member['_id']}
														checked={selectedContact?.['_id'] === member['_id']}
														onChange={() => handleSetLead(member)}
														className='cp'
														style={{ width: '18px', height: '18px', accentColor: '#2979ff' }}
													/>
												</label>
											</div>
										</div>
									)
								}) : (
									<div className='df jcc aic py2rem'>
										<span className='fs1rem c15'>No team members found</span>
									</div>
								)
							}
						</div>

						{/* Save Button */}
						<div className='df jcc mt2rem'>
							<button className='cp bg4 c1 fw400 fs1rem px3rem py0-5rem br15px' onClick={handleSavePreferredContact}>
								Save Preferred Contact
							</button>
						</div>
					</div>
				</div>
			</div >
		)
	};

	return (
		<AnimatedPage>
			<SuperFlowHeader page='Settings' company={company} breadcrum={['View', '/Settings', `/${selectedInvestorTab}`]} heading={`${user?.['role']} Settings`} />
			<div className="td250 px6rem py1rem w100 df setting-inverter-page-main">
				<div className="w80 mr1rem gg1rem bg1 setting-inverter-page">
					<div className="ttc df jcc tac">{indexTab && <p className="w100 c15 fs2rem fw500 mb1rem df aic jcc">
						{indexTab == "AdvisorMatch" ? <><span class='c4'>Advisor</span>Match
							<span className="cp mb2rem" onClick={() => dispatch(toggleModal({ open: 'howItWorksModal' }))}>
								<svg width="18" height="18" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
									<circle cx="13.5" cy="13.5" r="13.5" transform="matrix(1 0 0 -1 0 27)" fill="#59B8FD" />
									<path d="M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z" fill="white" />
									<path d="M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z" fill="white" />
								</svg>
							</span></> : indexTab}
					</p>}</div>
					{indexTab == "Companies House Data" &&
						<div class='w100 df jcc'>
							<button onClick={() => fetchCompany()} className='cp tac c1 bg3 bg4-hover br5px shadow px2rem py0-5rem fw500 mt1rem'>Refresh</button>
						</div>
					}

					{indexTab == "Companies House Data" && <>{companiesHouseData()}</>}
					{indexTab == "Company Profile" && <>{companyProfile()}</>}
					{indexTab == "Director's Information" && <>{directorsInfo()}</>}
					{user?.['role'] == 'Advisor'
						? <>
							{indexTab == "Advisor Permissions" && <>{permissionsTab()}</>}
							{indexTab == "AdvisorMatch" &&
								<AdvisorMatchCriteria
									user={user}
									company={company}
									advisors={advisors}
									setAdvisors={setAdvisors}
									clientMatchTabs={clientMatchTabs}
									selectedClientMatchTab={selectedClientMatchTab}
									setSelectedClientMatchTab={setSelectedClientMatchTab}
								/>
							}
						</>
						: user?.['role'] == 'Investor'
							? <>
								{indexTab == "Investor Permissions" && <>{permissionsTab()}</>}
								{indexTab == "InvestorMatch Criteria" &&
									<InvestorMatchCriteria
										user={user}
										company={company}
										options={options}
										isValid={isValid}
										ukRegions={ukRegions}
										setCompany={setCompany}
										companyContact={companyContact}
										setAuditLogList={setAuditLogList}
										investorMatchTabs={investorMatchTabs}
										setSelectedContact={setSelectedContact}
										selectedInvestorTab={selectedInvestorTab}
										setSelectedInvestorTab={setSelectedInvestorTab}
									/>}
								{indexTab == "Investment Leads" && <>{investmentLeads()}</>}
								{indexTab == "Preferred Contact For Leads" && <>{preferredContactForLeads()}</>}
							</>
							: <></>
					}
				</div>
				{getSidebarHTML()}
			</div>

			{/* Add Contact */}
			<Modal open={modal['open'] == 'addContact'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr oya">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<img className="w20 pa t0 l0 m1rem" src={require(`../../../../../images/logo.svg`)} alt="TODO" />
					<h1 className="text-gradient fw600 pb0-5rem">Add Investor Team Member</h1>
					<div className="df fdc gg1rem px2rem">
						<div className='form-group df jsc'>
							<div className='img-upload-area pr'>
								<div className='img-box pr'>
									<img src={newContact['profilePicture'] || require('../../../../../images/profile-photo.jpeg')} alt="Profile" className="profile-img w7rem h7rem advisor-profile shadow" />
									<div className='input-file'>
										<span className='add-btn bg5' onClick={() => { setIsImageModal(true), setUploadType('newContactImage'), setCurrentImage('') }}>
											<svg viewBox="0 0 487 487" className="zi3">
												<g>
													<path d="M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z
													M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9
													v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z
													M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z
													M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"/>
												</g>
											</svg>
										</span>
									</div>
								</div>
							</div>
						</div>
						<p className='mb0-5rem fs0-75rem tal df jcfs w100'>Please note that Contact can only be added if all fields are completed</p>
						<div className="dg gtcr2-md gg1rem">
							<div className="pr">
								<input
									name="firstName"
									type="text"
									placeholder="First Name"
									className="pl4rem shadow bg5 w100 br5px p1rem"
									value={newContact['firstName'] || ''}
									onChange={(event) => handleNewContactChange(event)}
								/>
								<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
									<path d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z" className="fa-secondary"></path>
								</svg>
							</div>
							<div className="pr">
								<input
									name="lastName"
									type="text"
									placeholder="Last Name"
									className="pl4rem shadow bg5 w100 br5px p1rem"
									value={newContact['lastName'] || ''}
									onChange={(event) => handleNewContactChange(event)}
								/>
								<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
									<path d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z" className="fa-secondary"></path>
								</svg>
							</div>
						</div>
						<div className="pr">
							<input
								name="email"
								type="email"
								placeholder="Email"
								className="pl4rem shadow bg5 w100 br5px p1rem"
								value={newContact['email'] || ''}
								onChange={(event) => handleNewContactChange(event)}
							/>
							<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 512 512">
								<path d="M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z" className="fa-secondary"></path>
								<path d="M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z" className="fa-primary"></path>
							</svg>
						</div>
						<div className="pr">
							<input
								name="phone"
								type="text"
								placeholder="Phone Number"
								className="pl4rem shadow bg5 w100 br5px p1rem"
								value={newContact['phone']}
								onChange={(event) => handleNewContactChange(event)}
							/>
							<svg className="center-vertically f3 pa l0 ml1rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
								<path className="fa-primary" d="M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z" />
								<path className="fa-secondary" d="M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z" />
							</svg>
						</div>
						<div className="pr">
							<input
								name="linkedIn"
								type="url"
								placeholder="LinkedIn"
								className="pl4rem shadow bg5 w100 br5px p1rem"
								value={newContact['linkedIn']}
								onChange={(event) => handleNewContactChange(event)}
							/>
							<svg className="center-vertically f3 pa l0 ml1rem w2rem" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 310">
								<g>
									<path id="XMLID_802_" d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
										C77.16,101.969,74.922,99.73,72.16,99.73z"/>
									<path id="XMLID_803_" d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
										c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"/>
									<path id="XMLID_804_" d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
										c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
										c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
										C310,145.43,300.549,94.761,230.454,94.761z"/>
								</g>
							</svg>
						</div>
						<div className='df jcsb tar mt1rem'>
							<button className="pr shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem w30 usn cp ttu bsbb tac" onClick={() => addNewContact()}>
								Add Contact
								<span className="tooltip-area-custom cp" style={{ top: '-8px', right: '-8px' }}>
									<i className="icon">
										<img className="h2rem" src={require(`../../../../../images/info-icon.svg`)} alt="" />
										<div className="overlay-box" style={{ left: 'auto', top: '0', right: '-380px' }}>
											<p className="fs0-75rem c6">We want to provide a great experience to both investors and applicant companies. We recognize that you may not be the correct contact but ask you that you complete all the fields for any individual named as replacement. We ask that the contact email not be enquiries@vcname.com etc. We want our curated leads to go to a named individual for assessment.<br /><br /> Thank you,<br /> Diligentsia Team</p>
										</div>
									</i>
								</span>
							</button>
							<div className="df jce">
								<div>
									<div className="fs0-75rem">
										<label>Designate as main recipient for leads</label>
										<div className='switch-box'>
											<Switch
												name="isMainRecipient"
												className="success"
												checked={isMainRecipient}
												onChange={(event) => handleNewContactChange(event)}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal>

			{/* Officers Read More */}
			<Modal open={modal['open'] == 'officersReadMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
					<div className='avtar-area df jcc'>
						<img className="h2rem" src={require(`../../../../../images/officersavatar.png`)} alt="" />
					</div>
					<h3 className='text-gradient fs1-5rem tac'>Officers</h3>
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })); setOfficersReadMore({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='c15 group-inputs mt2rem'>
						<p className='mb0-5rem ttc'><b>Name:</b>  {officersReadMore['name'] ? officersReadMore['name'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Role:</b>  {officersReadMore['officer_role'] ? officersReadMore['officer_role'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Address:</b> {officersReadMore['address']
							? <>{officersReadMore['address']['premises'] && officersReadMore['address']['premises']}
								{officersReadMore['address']['address_line_1'] && ', ' + officersReadMore['address']['address_line_1']}
								{officersReadMore['address']['address_line_2'] && ', ' + officersReadMore['address']['address_line_2']}
								{officersReadMore['address']['locality'] && ' - ' + officersReadMore['address']['locality']}
								{officersReadMore['address']['region'] && ', ' + officersReadMore['address']['region']}
								{officersReadMore['address']['country'] && ', ' + officersReadMore['address']['country']}
							</>
							: '-'
						}</p>
						<p className='mb0-5rem ttc'><b>Nationality:</b>  {officersReadMore['nationality'] ? officersReadMore['nationality'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Occupation:</b>  {officersReadMore['occupation'] ? officersReadMore['occupation'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>DOB:</b>  {officersReadMore['date_of_birth'] ? officersReadMore['date_of_birth']['month'] + '/' + officersReadMore['date_of_birth']['year'] : '-'}</p>
					</div>
				</div>
			</Modal>

			{/* Controls Read More */}
			<Modal open={modal['open'] == 'controlReadMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
					<div className='avtar-area df jcc'>
						<img className="h2rem" src={require(`../../../../../images/officersavatar.png`)} alt="" />
					</div>
					<h3 className='text-gradient fs1-5rem tac'>Persons with Significant Control</h3>
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })); setControlReadMore({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='c15 group-inputs mt2rem'>
						<p className='mb0-5rem ttc'><b>Name:</b>  {controlReadMore['name'] ? controlReadMore['name'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Controls:</b>
							{controlReadMore['natures_of_control'] && controlReadMore['natures_of_control'].length > 0
								? <>{controlReadMore['natures_of_control'].map((control, idx) => (
									<ul key={idx}><li>{control}</li></ul>
								))}</>
								: '-'}</p>
						<p className='mb0-5rem ttc'><b>E-Tag:</b>  {controlReadMore['etag'] ? controlReadMore['etag'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Notified Date:</b>  {controlReadMore['notified_on'] ? controlReadMore['notified_on'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Address:</b> {controlReadMore['address']
							? <>{controlReadMore['address']['premises'] && controlReadMore['address']['premises']}
								{controlReadMore['address']['address_line_1'] && ', ' + controlReadMore['address']['address_line_1']}
								{controlReadMore['address']['address_line_2'] && ', ' + controlReadMore['address']['address_line_2']}
								{controlReadMore['address']['locality'] && ' - ' + controlReadMore['address']['locality']}
								{controlReadMore['address']['region'] && ', ' + controlReadMore['address']['region']}
								{controlReadMore['address']['country'] && ', ' + controlReadMore['address']['country']}
							</>
							: '-'
						}</p>
						<p className='mb0-5rem ttc'><b>Nationality:</b>  {controlReadMore['nationality'] ? controlReadMore['nationality'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>DOB:</b>  {controlReadMore['date_of_birth'] ? controlReadMore['date_of_birth']['month'] + '/' + controlReadMore['date_of_birth']['year'] : '-'}</p>
					</div>
				</div>
			</Modal>

			{/* Charge Read More */}
			<Modal open={modal['open'] == 'chargeReadMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
					<div className='avtar-area df jcc'>
						<img className="h2rem" src={require(`../../../../../images/officersavatar.png`)} alt="" />
					</div>
					<h3 className='text-gradient fs1-5rem tac'>Charges</h3>
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })); setChargeReadMore({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='c15 group-inputs mt2rem'>
						<p className='mb0-5rem ttc'><b>Persons Entitled:</b>  {chargeReadMore['persons_entitled'] ? chargeReadMore['persons_entitled'][0]['name'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Charge Description:</b>  {chargeReadMore['classification'] ? chargeReadMore?.['classification']?.['description'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Status:</b>  {chargeReadMore['status'] ? chargeReadMore['status'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>E-Tag:</b>  {chargeReadMore['etag'] ? chargeReadMore['etag'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Charge Number:</b>  {chargeReadMore['charge_number'] ? chargeReadMore['charge_number'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Delivered On:</b>  {chargeReadMore['delivered_on'] ? chargeReadMore['delivered_on'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Satisfied On:</b>  {chargeReadMore['satisfied_on'] ? chargeReadMore['satisfied_on'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Short Particulars:</b>  {chargeReadMore['particulars'] ? chargeReadMore?.['particulars']?.['description'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Amount secured description:</b>  {chargeReadMore['secured_details'] ? chargeReadMore?.['secured_details']?.['description'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Transaction filing type:</b>  {chargeReadMore['transactions'] ? chargeReadMore?.['transactions']?.['filing_type'] : '-'}</p>
						<p className='mb0-5rem ttc'><b>Transaction filing Delivered On:</b>  {chargeReadMore['transactions'] ? chargeReadMore?.['transactions']?.['delivered_on'] : '-'}</p>
					</div>
				</div>
			</Modal>

			{/* Upload CV Data */}
			<Modal open={modal['open'] == 'uploadCvData'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => closeDirectorPopup()}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="c15 fs1-25rem fw600 mt0-5rem">Director CV Info</h1>
					<div className='group-inputs mt2rem'>
						<h3 className='c14 fs1rem fw500 mb0-5rem'>Upload CV Here</h3>
						<label for="fileUpload" className="w100 bsbb bg5 br5px df jcc aic p1rem bsd bo6 bw2px cp">
							<span className="c3 pen fs1rem fw500 df aic tac">
								<svg class='mr0-5rem' width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_2183_912)">
										<path d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z" fill="white" />
										<path d="M11.4914 17.7883C10.4699 17.7883 9.44852 17.7883 8.4273 17.7883C7.02663 17.7883 6.01589 16.7811 6.0087 15.3809C6.00601 14.8922 6.00601 14.4033 6.0087 13.9142C6.0114 13.4102 6.31687 13.0859 6.78406 13.085C7.25124 13.0841 7.56076 13.4062 7.5639 13.9097C7.56704 14.4133 7.5639 14.9052 7.5639 15.4029C7.56749 15.9249 7.87431 16.229 8.3981 16.2295C10.4672 16.2295 12.5362 16.2295 14.605 16.2295C15.1292 16.2295 15.4365 15.9249 15.4405 15.4034C15.4441 14.9056 15.4405 14.4079 15.4405 13.9102C15.4405 13.4124 15.7509 13.0841 16.2199 13.085C16.6889 13.0859 16.9988 13.4102 16.9948 13.9138C16.9899 14.5503 17.0253 15.1936 16.9454 15.8216C16.7989 16.9707 15.8192 17.782 14.6566 17.7874C13.6041 17.7905 12.5475 17.7883 11.4914 17.7883Z" fill="#4A67FF" />
										<path d="M10.726 7.89412C10.6074 8.00463 10.5377 8.06527 10.473 8.13041C9.97531 8.63309 9.48027 9.13891 8.98029 9.63978C8.62541 9.99557 8.13082 10.0216 7.81008 9.71031C7.48934 9.399 7.50192 8.88824 7.85096 8.53695C8.86709 7.51453 9.88652 6.4957 10.9092 5.48047C11.2686 5.12109 11.7385 5.12109 12.0979 5.48047C13.1275 6.50169 14.1529 7.52726 15.1741 8.55717C15.5101 8.89633 15.5119 9.40619 15.1997 9.71076C14.8875 10.0153 14.3911 10.0019 14.0484 9.6618C13.5408 9.15643 13.0408 8.64297 12.5368 8.13445C12.4716 8.06887 12.402 8.00777 12.2982 7.90984C12.2915 8.0509 12.2834 8.14209 12.2834 8.23328C12.2834 9.84104 12.2856 11.4483 12.2834 13.0561C12.2834 13.6594 11.7524 14.0183 11.2003 13.8036C10.8949 13.6846 10.7291 13.4195 10.7291 13.0314C10.7273 11.4412 10.7273 9.85107 10.7291 8.26113L10.726 7.89412Z" fill="#4A67FF" />
									</g>
									<defs><clipPath id="clip0_2183_912"><rect width="23" height="23" fill="white" /></clipPath></defs>
								</svg>
								Upload
							</span>
							<input onChange={(e) => setAttachment(e.target.files[0])} className="dn" id="fileUpload" type="file" />
						</label>
						{attachment &&
							<div className='df aic my1rem'>
								<i class="fa fa-circle c4" style={{ fontSize: '10px' }} aria-hidden="true" />
								<a target="_blank" href={attachment?.location} className="c3 fs0-75rem fw500 tdu">
									<span className="px0-5rem">{attachment?.name}</span>
								</a>
							</div>}
						<div className='df jcse'>
							<span onClick={() => handleSubmitDirector()} className="df aic jcc cp bg4 c1 br20px px3rem py0-75rem fw500 mt2rem">Submit</span>
						</div>
					</div>
				</div>
			</Modal>

			{/* Delete File */}
			<Modal open={modal['open'] == 'deleteFiles'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs2rem fw600 my1rem">Delete File</h1>
					<h2 className="c4 fs1rem fs1-5rem-sm ttu w100 tac mb1rem">Are you sure you want to delete this file?</h2>
					<p className="fs1-25rem fw500 mb1rem">{attachment && attachment.originalname}</p>
					<span onClick={() => confirmDeleteFiles()} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic">Delete File</span>
					<span onClick={() => dispatch(toggleModal({ open: '' }))} className="c3-hover td250 fs1-25rem cp">Cancel</span>
				</div>
			</Modal>

			{/* Audit Logs */}
			<Modal open={modal['open'] == 'auditLogs'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-5rem fw600 tac ttu">{company['cName']} Company Audit Log</h1>
					<h2 className="c4 fs0-75rem ttu w100 tac mb1rem">See the history of Company Audit Updated</h2>
					<div className="ma oya dg gg0-5rem mb2rem w100">
						<div className='df'>

							<span className='fs1rem ml1rem'><b>Company Details</b></span>
						</div>
						<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Name:</span> {company['cName']}</p>
							{company?.['creatorId'] && <p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Owner:</span> {company['creatorId']['firstName'] + ' ' + company['creatorId']['lastName']}</p>}
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Created At:</span> {moment(company['creaedAt']).format('ll')}</p>
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Payment Source:</span> {company['paymentSource']}</p>
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Stage of development:</span> {company['cStage']}</p>
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Objectives:</span> {company['testType']}</p>
						</div>
						{auditLogList && auditLogList.length > 0 && auditLogList.map(log => {
							return (
								<div className="df my0-5rem">
									{(log?.['userId']?.['profile'] || log?.['userId']?.['profilePicture'])
										&& <img className={`ass ml0-5rem br100 w2rem h2rem client-profile`} src={(log?.['userId']?.['profile'] || log?.['userId']?.['profilePicture'])} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
										|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem client-profile`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
									}
									<div className="w100">
										<span className='fs0-75rem ml1rem'><b>{log['message']}</b> at <b>{new Date(log.timestamp).toLocaleString()}</b> by <b>{log?.['userId']['firstName']} {log?.['userId']['lastName']}</b></span>
										{/* Company Info Logs */}
										{log['payload']['update'] &&
											<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
												<p className="df fw500 fs1rem">Changes to {company['cName']} - Company Details:</p>
												<div className="df w100">
													<div className="mr0-5rem">
														{Object.keys(log['payload']['update']).map(key => {
															return <p className="fw600">{companyKeys[key]}:</p>
														})}
													</div>
													<div>
														{Object.values(log['payload']['update']).map(value => {
															return <p>{typeof (value) == 'string' ? value : (typeof (value) == 'boolean' && value) ? 'True' : 'False'}</p>
														})}
													</div>
												</div>
											</div>
										}
										{/* Company Group Logs */}
										{log['payload']?.['data']?.['childUpdates'] && log['payload']?.['data']?.['childUpdates'].length > 0 &&
											<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
												<p className="df fw500 fs1rem">{log['payload']['data']['type'] && log['payload']['data']['type']} Group Info:</p>
												{log['payload']?.['data']?.['childUpdates'].map(data => {
													return <>
														{companies && companies.length > 0 && companies.map(company => {
															if (company['_id'] == log['payload']?.['data']?.['parentId']) {
																if (company['childrenCompanies']) {
																	for (let childCompnay of company['childrenCompanies']) {
																		if (childCompnay['_id'] == data['companyId']) {
																			return <p><span className='fw600'>Company Name:</span> {childCompnay['cName']}</p>
																		}
																	}
																}
															}
														})}
														<p><span className='fw600'>Group:</span> {data['group']}</p>
														<p><span className='fw600'>Percentage:</span> {data['percentage']}%</p>
													</>
												})}
											</div>
										}
										{/* Company Directors Logs */}
										{log['payload']['directorId'] &&
											<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
												<p className="df fw500 fs1rem">Changes to {log['payload']['directorId']['name']} - Director's Information:</p>
												<p className='df fw500'><span className='fw600 mr0-5rem'>CV:</span>
													{log['files'].length > 0 && log['files'].map(file => (
														<a className="fw400 mr0-5rem fs0-75rem tdu" target="_blank" href={file?.location}><span>{file?.originalname}</span></a>
													))}
												</p>
												<p className='df fw500'><span className='fw600 mr0-5rem'>LinkedIn:</span>
													{log['payload']['linkedIn'] && log['payload']['linkedIn'] !== 'undefined'
														? <a className="fw400 mr0-5rem fs0-75rem tdu" target="_blank" href={log['payload']['linkedIn']}>{log['payload']['linkedIn']}</a> : '-'}
												</p>
											</div>
										}
									</div>
								</div>
							)
						})
						}
					</div>
				</div>
			</Modal>

			{/* Upload Image */}
			<Modal open={isImageModal} onClose={() => setIsImageModal(false)} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br5px pr">
					<div className={`top-header py1rem px2rem df jcsb aic ${user['role'] == 'Advisor' ? 'advisor-bg' : 'investor-bg'}`} style={{ borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>Upload Profile Picture</h4>
						<img className="w60px" src={require(`../../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className='df fdc p3rem'>
						{currentImage == ''
							? <label for="profile" className="w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area">
								<span className="pen fs1rem fw500 tac">Upload picture</span><br />
								<div className='input-btn pa t0 w100 op0 l0 cp'>
									<input className='w100 l0 h5rem cp' onChange={(e) => handleImage(e)} id="currentImage" type="file" accept="image/jpeg, image/jpg, image/png" />
								</div>
								<label >Max file size 5MB</label>
							</label>
							: <div className='img-box pr'>
								<Cropper
									ref={cropper}
									guides={false}
									aspectRatio={1 / 1}
									className='cropper-settings'
									src={currentImage}
								/>
							</div>
						}
						<div className="df jcse">
							<span onClick={() => setIsImageModal(false)} className="shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">Cancel</span>
							<span onClick={() => uploadImage()} className="shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">
								{Object.keys(currentImage).length == 0
									? 'Upload'
									: 'Crop & Upload'
								}
							</span>
						</div>
					</div>
				</div>
			</Modal>

			{/* How It Works */}
			<Modal open={modal['open'] == 'howItWorks'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="bg1 shadow w100 pt4rem pb0-5rem px2rem bsbb df fdc maw900px pr br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../../images/logo.svg`)} alt="TODO" />
					<h1 className="text-gradient fw600 pb0-5rem">How does it work?</h1>
					<div className="tac my0-5rem">
						<ul className='how-it-works taj'>
							<li className='mb0-5rem'>Qualify unsolicited approaches to your Web site for funding</li>
							<li className='mb0-5rem'>Add FREE Diligentsia widget to your website In minutes</li>
							<li className='mb0-5rem'>Fully automated - saves your staff time on qualification of poor fit approaches</li>
							<li className='mb0-5rem'>Reserves human interaction for high value target company interactions - still very important</li>
							<li className='mb0-5rem'>Automated reporting - completeness, fit</li>
							<li className='mb0-5rem'>Sits within a complete set of automated modules to improve investment success Rates</li>
							<li className='mb0-5rem'>Valuable report for the enquiring Company - its approach not wasted even if unsuccessful - generates goodwill for your firm</li>
							<li className='mb0-5rem'>Receive qualified leads that appear to meet your investment criteria</li>
							<li className='mb0-5rem'>You create FREE questionnaire in  minutes and Attach to your web site</li>
							<li className='mb0-5rem'>You can add/edit sections and questions to Bespoke it to your firm's requirements</li>
							<li className='mb0-5rem'>Companies approaching your firm for funding Via your web site are directed to complete the questionnaire</li>
							<li className='mb0-5rem'>Automated emails can be generated - Interested/thank you but not a close enough fit</li>
							<li className='mb0-5rem'>Process workflow management from your Investor dashboard</li>
							<li className='mb0-5rem'>If you wish to progress, other modules can Be added to that company's account eg:
								<ul style={{ listStyleType: "initial" }}>
									<li>Detailed Due Diligence Questionnaire</li>
									<li>Warranty Disclosures</li>
									<li>Directors' Questionnaires</li>
									<li>Data Repository</li>
									<li>Business Audit</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
			</Modal>

			{/* Delete Company */}
			<Modal open={modal['open'] == 'companyDelete'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h3 className="company-name fs1-25rem">{company['cName']}</h3>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../../images/logo.svg`)} alt="TODO" />
					<div className='df jcc'><h1 className="text-gradient fw600">Delete Company</h1></div>
					<div className="tac my2rem">
						<p>To delete the Advisor Company you need to book a call</p>
					</div>
					<div className="df jcc">
						<a href="https://koalendar.com/e/meet-with-mark-bernstein" target="_blank" className="w9rem shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 cp ttu bsbb tac fs0-75rem mb0-5rem">
							<i className="icon">
								<svg className="w1rem f1 pr mr0-5rem tp5px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 202.592 202.592">
									<g>
										<g>
											<path d="M198.048,160.105l-31.286-31.29c-6.231-6.206-16.552-6.016-23.001,0.433l-15.761,15.761
														c-0.995-0.551-2.026-1.124-3.11-1.732c-9.953-5.515-23.577-13.074-37.914-27.421C72.599,101.48,65.03,87.834,59.5,77.874
														c-0.587-1.056-1.145-2.072-1.696-3.038l10.579-10.565l5.2-5.207c6.46-6.46,6.639-16.778,0.419-23.001L42.715,4.769
														c-6.216-6.216-16.541-6.027-23.001,0.433l-8.818,8.868l0.243,0.24c-2.956,3.772-5.429,8.124-7.265,12.816
														c-1.696,4.466-2.752,8.729-3.235,12.998c-4.13,34.25,11.52,65.55,53.994,108.028c58.711,58.707,106.027,54.273,108.067,54.055
														c4.449-0.53,8.707-1.593,13.038-3.275c4.652-1.818,9.001-4.284,12.769-7.233l0.193,0.168l8.933-8.747
														C204.079,176.661,204.265,166.343,198.048,160.105z M190.683,176.164l-3.937,3.93l-1.568,1.507
														c-2.469,2.387-6.743,5.74-12.984,8.181c-3.543,1.364-7.036,2.24-10.59,2.663c-0.447,0.043-44.95,3.84-100.029-51.235
														C14.743,94.38,7.238,67.395,10.384,41.259c0.394-3.464,1.263-6.95,2.652-10.593c2.462-6.277,5.812-10.547,8.181-13.02l5.443-5.497
														c2.623-2.63,6.714-2.831,9.112-0.433l31.286,31.286c2.394,2.401,2.205,6.492-0.422,9.13L45.507,73.24l1.95,3.282
														c1.084,1.829,2.23,3.879,3.454,6.106c5.812,10.482,13.764,24.83,29.121,40.173c15.317,15.325,29.644,23.27,40.094,29.067
														c2.258,1.249,4.32,2.398,6.17,3.5l3.289,1.95l21.115-21.122c2.634-2.623,6.739-2.817,9.137-0.426l31.272,31.279
														C193.5,169.446,193.31,173.537,190.683,176.164z"/>
										</g>
									</g>
								</svg>
							</i>
							Book a call
						</a>
					</div>
				</div>
			</Modal>

			{/* How It Works Popup - AdvisorMatch */}
			<Modal id="howItWorksModal" open={modal['open'] == 'howItWorksModal'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw df jcc aic advisor-dashboard-seemore" >
				<div className="poppins-font-style mah100 bg20 shadow w100 px4rem py2rem df fdc m1rem pr br10px pr" style={{ outline: 'none', zoom: '0.9', maxWidth: '1350px' }}>
					<div className='df fww w100'>
						<h2 className='w100 tac c15 fs1-75rem fw500 mt1rem'>Simple onboarding ramp</h2>
						<h6 className='w100 tac c3 fs1-25rem fw500 mb2rem'>Show value in minutes WITHOUT using client data</h6>
						<div className='step-top-box df w100 jcc'><img src={require('../../../../../images/step-modal-img.png')} className="w70" style={{ objectFit: 'fill' }} /></div>
						<div className='step-box-images df jcsb mt1rem mb2rem mla mra'>
							<div className='step-img df jcc px1rem'><img className='' src={require('../../../../../images/advisor-dashboard/add-client-1.png')} alt="step image" /></div>
							<div className='step-img df jcc px1rem'><img className='' src={require('../../../../../images/advisor-dashboard/add-client-2.png')} alt="step image" /></div>
							<div className='step-img df jcc px1rem'><img className='' src={require('../../../../../images/advisor-dashboard/add-client-3.png')} alt="step image" /></div>
						</div>
						<div className='checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb'>
							<div className='checklist-inner w100 df jcc'><span className='c15 fs1rem fsi fw500'>Start free. Prove fast. Upgrade only when your client clearly sees the impact.</span></div>
						</div>
					</div>
					<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

		</AnimatedPage >
	);
}